import React from 'react'

export const Iconaction = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#7E868F'>
        <g>
          <path
            d='M4 10c1.38 0 2.5 1.12 2.5 2.5S5.38 15 4 15s-2.5-1.12-2.5-2.5S2.62 10 4 10zm8 0c1.38 0 2.5 1.12 2.5 2.5S13.38 15 12 15s-2.5-1.12-2.5-2.5S10.62 10 12 10zm8 0c1.38 0 2.5 1.12 2.5 2.5S21.38 15 20 15s-2.5-1.12-2.5-2.5S18.62 10 20 10z'
            transform='translate(-1263 -1957) translate(1263 1957)'
          />
        </g>
      </g>
    </g>
  </svg>
)

export const IconCheck = () => (
  <svg
    viewBox='64 64 896 896'
    focusable='false'
    data-icon='check-circle'
    width='24'
    height='24'
    fill='currentColor'
    aria-hidden='true'
  >
    <path d='M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z'></path>
    <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'></path>
  </svg>
)

export const IconBack = () => (
  <span className='anticon anticon-back'>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 64 64'
      fill='currentColor'
    >
      <path d='M54 30H14.101l15.278-14.552a2 2 0 10-2.759-2.897L9.172 29.171A3.978 3.978 0 008 32c0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552a1.999 1.999 0 001.38-3.448L14.038 34H54a2 2 0 000-4z'></path>
    </svg>
  </span>
)

export const IconNotification = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <g transform='translate(-1342 -19) translate(1342 19) translate(1 1)'>
            <g fill='#262626'>
              <path
                d='M10.412.25c4.312 0 7.809 3.496 7.809 7.809v5.882c0 2.09.65 3.391 1.938 4.035.708.354.456 1.421-.335 1.421l-6.4.001c-.337 1.35-1.557 2.352-3.012 2.352S7.736 20.749 7.4 19.398H1c-.791 0-1.043-1.068-.335-1.422 1.288-.644 1.938-1.944 1.938-4.035V8.06c0-4.215 3.345-7.666 7.559-7.805zm1.416 19.148H8.995c.27.507.803.852 1.417.852s1.147-.345 1.416-.852zM10.424 1.75l-.225.004c-3.394.112-6.096 2.9-6.096 6.305v5.882c0 1.61-.348 2.924-1.046 3.913l-.032.043H17.8l-.032-.043c-.699-.989-1.046-2.303-1.046-3.913V8.06c0-3.484-2.825-6.31-6.297-6.31z'
                transform='translate(0 1)'
              />
            </g>
            <circle cx='17' cy='4' r='4' fill='#F44336' />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const IconMenu = () => (
  <svg
    viewBox='64 64 896 896'
    focusable='false'
    data-icon='menu'
    width='24'
    height='24'
    fill='currentColor'
    aria-hidden='true'
  >
    <path d='M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'></path>
  </svg>
)

export const IconMessages = () => (
  <svg
    viewBox='64 64 896 896'
    focusable='false'
    data-icon='message'
    width='24'
    height='24'
    fill='currentColor'
    aria-hidden='true'
  >
    <path d='M464 512a48 48 0 1096 0 48 48 0 10-96 0zm200 0a48 48 0 1096 0 48 48 0 10-96 0zm-400 0a48 48 0 1096 0 48 48 0 10-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 00-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 00-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 00112 714v152a46 46 0 0046 46h152.1A449.4 449.4 0 00510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 00142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'></path>
  </svg>
)

export const Iconadminmodule = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <path
              d='M22.047 3.187C16.52 2.706 13.395.48 13.395.455c-.809-.607-1.953-.607-2.762 0-.028.026-3.154 2.251-8.68 2.732C.837 3.287 0 4.122 0 5.134 0 19.296 10.688 23.67 11.135 23.848c.279.101.558.152.865.152.307 0 .586-.05.865-.152C13.312 23.671 24 19.296 24 5.134c0-1.012-.837-1.846-1.953-1.947zM11.972 22.129c-.167-.076-2.093-.86-4.186-2.808l.28-2.2c.167-1.214 1.283-2.124 2.622-2.124h2.596c1.34 0 2.483.91 2.623 2.124l.279 2.2c-2.065 1.948-4.019 2.732-4.214 2.808zM12 12.72c-1.34 0-2.428-.987-2.428-2.2 0-1.214 1.088-2.2 2.428-2.2 1.34 0 2.428.986 2.428 2.2 0 1.213-1.088 2.2-2.428 2.2zm6.056 4.577L18 16.894c-.195-1.568-1.34-2.833-2.847-3.44.838-.759 1.368-1.795 1.368-2.933 0-2.251-2.037-4.097-4.521-4.097S7.48 8.27 7.48 10.52c0 1.163.53 2.2 1.367 2.933-1.507.582-2.652 1.872-2.847 3.44l-.056.404c-2.037-2.655-3.795-6.575-3.767-12.19 6.307-.556 9.767-3.16 9.879-3.16.14.1 3.628 2.63 9.795 3.16l.056.051c0 5.59-1.786 9.51-3.851 12.14z'
              transform='translate(-144 -2563) translate(88 2392) translate(56.883 171)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconlogo = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='166'
    height='47'
    viewBox='0 0 166 47'
  >
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <g>
            <g>
              <path
                fill='#53C3BD'
                fillRule='nonzero'
                d='M34.266 7.968c-2.946 0-5.34.965-7.177 2.895-1.839 1.93-2.758 4.362-2.758 7.296s.913 5.36 2.738 7.276c1.826 1.917 4.225 2.875 7.197 2.875 3 0 5.418-.958 7.256-2.875 1.839-1.916 2.758-4.342 2.758-7.276 0-2.908-.932-5.334-2.797-7.276-1.864-1.943-4.27-2.915-7.217-2.915zm0 3.768c1.721 0 3.143.627 4.264 1.883 1.12 1.256 1.682 2.769 1.682 4.54 0 1.798-.541 3.305-1.623 4.52-1.082 1.216-2.523 1.824-4.323 1.824-1.799 0-3.233-.608-4.302-1.824-1.07-1.215-1.604-2.722-1.604-4.52 0-1.798.541-3.318 1.623-4.56 1.083-1.242 2.51-1.863 4.283-1.863zM62.078 8.326L59.183 15.423 56.132 23.711 52.729 14.63 50.147 8.326 45.688 8.326 53.903 27.993 58.322 27.993 66.498 8.326z'
                transform='translate(-637 -197) translate(461 149) translate(176 48) translate(0 3.896)'
              />
              <path
                fill='#000'
                fillRule='nonzero'
                d='M111.872 19.666c.365-3.86-.352-6.794-2.151-8.803-1.8-2.01-4.316-3.014-7.55-3.014-2.999 0-5.437.952-7.314 2.855-1.878 1.903-2.817 4.35-2.817 7.336 0 3.146.946 5.657 2.836 7.534 1.891 1.877 4.414 2.815 7.569 2.815 1.564 0 3.097-.29 4.596-.872 1.5-.582 2.732-1.4 3.697-2.459l-2.622-2.578c-.573.635-1.388 1.144-2.445 1.527-1.056.383-2.105.575-3.148.575-1.748 0-3.188-.45-4.323-1.348-1.134-.899-1.793-2.089-1.975-3.569h15.647zm-15.568-3.45c.313-1.507 1.01-2.67 2.093-3.489 1.082-.82 2.379-1.23 3.891-1.23 1.644 0 2.98.41 4.01 1.23 1.03.82 1.597 1.982 1.702 3.49H96.304zM134.677 27.914V17.406c0-2.908-.776-5.194-2.328-6.86-1.552-1.665-3.54-2.498-5.965-2.498-2.504 0-4.668 1.044-6.493 3.132l-.235-2.855h-3.677v19.588h4.03v-10.23c0-1.639.508-3.027 1.526-4.164 1.017-1.136 2.307-1.705 3.872-1.705 1.643 0 2.92.51 3.833 1.527.913 1.017 1.37 2.386 1.37 4.104v10.468h4.067zM142.782 8.286v19.628h-4.03V8.286h4.03zm-4.499-5.67c0 1.057.418 1.804 1.252 2.24.835.436 1.67.436 2.504 0 .834-.436 1.252-1.183 1.252-2.24 0-1.058-.418-1.798-1.252-2.22-.835-.424-1.67-.424-2.504 0-.834.422-1.252 1.162-1.252 2.22zM165.829 19.666c.366-3.86-.352-6.794-2.151-8.803-1.8-2.01-4.316-3.014-7.55-3.014-2.999 0-5.437.952-7.314 2.855-1.878 1.903-2.817 4.35-2.817 7.336 0 3.146.945 5.657 2.836 7.534 1.891 1.877 4.414 2.815 7.57 2.815 1.564 0 3.096-.29 4.595-.872 1.5-.582 2.732-1.4 3.697-2.459l-2.621-2.578c-.574.635-1.388 1.144-2.445 1.527-1.056.383-2.106.575-3.149.575-1.747 0-3.188-.45-4.322-1.348-1.135-.899-1.793-2.089-1.975-3.569h15.646zm-15.568-3.45c.312-1.507 1.01-2.67 2.092-3.489 1.082-.82 2.38-1.23 3.892-1.23 1.643 0 2.98.41 4.01 1.23 1.03.82 1.597 1.982 1.701 3.49h-11.695z'
                transform='translate(-637 -197) translate(461 149) translate(176 48) translate(0 3.896)'
              />
              <path
                fill='#53C3BD'
                d='M6.945 12.619c-1.243-.859-1.896-2.035-1.96-3.528-.637.361-1.24.785-1.804 1.26C.96 12.214.031 14.744.031 17.636c0 2.788.803 5.329 2.868 7.232 2.082 1.918 4.723 2.62 7.491 2.62 1.512 0 3.053.273 4.351 1.097 1.063.675 1.604 1.606 1.604 2.882 0 1.3-.513 2.25-1.636 2.887-5.018 2.842-10.66 1.213-13.423-3.879L.3 28.657l-.042 2.076c-.051 2.539.803 4.726 2.78 6.332 2.08 1.69 4.66 2.275 7.278 2.275 2.555 0 5.008-.583 7.146-2.037 2.05-1.395 3.1-3.368 3.1-5.873 0-3.1-1.616-5.055-4.146-6.172 1.149-.604 2.111-1.464 2.838-2.615.96-1.522 1.42-3.203 1.42-5.006 0-3.057-1.634-6.116-4.076-7.974-1.723-1.31-3.377-1.49-5.401-1.808-.892-.14-1.366-.67-.323-1.924.36-.433.786-.879 1.222-1.234l1.934-1.577c-2.83.709-7.505 1.952-7.207 5.828.093 1.199.69 2.067 1.943 2.507 2.217.775 3.99.074 6.023 1.841 1.304 1.133 1.782 2.669 1.782 4.379 0 1.658-.553 3.066-1.717 4.234-1.217 1.221-2.725 1.725-4.425 1.725-1.674 0-3.219-.442-4.486-1.575-1.286-1.15-1.749-2.725-1.769-4.428 0-1.711.496-3.233 1.83-4.348.298-.247.612-.47.942-.664z'
                transform='translate(-637 -197) translate(461 149) translate(176 48) translate(0 3.896)'
              />
              <path
                fill='#000'
                fillRule='nonzero'
                d='M74.11 12.619c-1.242-.859-1.895-2.035-1.958-3.528-.638.361-1.24.785-1.805 1.26-2.222 1.864-3.15 4.394-3.15 7.286 0 2.788.802 5.329 2.867 7.232 2.082 1.918 4.723 2.62 7.492 2.62 1.511 0 3.052.273 4.351 1.097 1.063.675 1.603 1.606 1.603 2.882 0 1.3-.512 2.25-1.636 2.887-5.018 2.842-10.659 1.213-13.422-3.879l-.987-1.819-.042 2.076c-.051 2.539.802 4.726 2.78 6.332 2.079 1.69 4.659 2.275 7.278 2.275 2.555 0 5.008-.583 7.146-2.037 2.05-1.395 3.1-3.368 3.1-5.873 0-3.1-1.616-5.055-4.146-6.172 1.149-.604 2.111-1.464 2.838-2.615.96-1.522 1.42-3.203 1.42-5.006 0-3.057-1.634-6.116-4.076-7.974-1.723-1.31-3.377-1.49-5.4-1.808-.893-.14-1.367-.67-.324-1.924.36-.433.786-.879 1.222-1.234l1.934-1.577c-2.829.709-7.505 1.952-7.206 5.828.092 1.199.688 2.067 1.942 2.507 2.217.775 3.99.074 6.023 1.841 1.303 1.133 1.782 2.669 1.782 4.379 0 1.658-.553 3.066-1.717 4.234-1.217 1.221-2.725 1.725-4.425 1.725-1.675 0-3.22-.442-4.486-1.575-1.286-1.15-1.749-2.725-1.77-4.428 0-1.711.496-3.233 1.83-4.348.298-.247.612-.47.942-.664z'
                transform='translate(-637 -197) translate(461 149) translate(176 48) translate(0 3.896)'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const CaretDownIcon = () => {
  return (
    <>
      <svg
        width='12'
        height='7'
        viewBox='0 0 12 7'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          d='M9.96973 0.219727L11.0304 1.28039L6.00006 6.31072L0.969727 1.28039L2.03039 0.219727L6.00006 4.1894L9.96973 0.219727Z'
          fill='#7E868F'
        />
      </svg>
    </>
  )
}

export const SelectItemIcon = () => {
  return (
    <>
      <svg
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        width='122.881px'
        height='122.88px'
        viewBox='0 0 122.881 122.88'
      >
        <g>
          <path
            fillRule='evenodd'
            d='M61.44,0c33.933,0,61.441,27.507,61.441,61.439 c0,33.933-27.508,61.44-61.441,61.44C27.508,122.88,0,95.372,0,61.439C0,27.507,27.508,0,61.44,0L61.44,0z M34.106,67.678 l-0.015-0.014c-0.785-0.718-1.207-1.685-1.256-2.669c-0.049-0.982,0.275-1.985,0.984-2.777c0.01-0.011,0.019-0.021,0.029-0.031 c0.717-0.784,1.684-1.207,2.668-1.256c0.989-0.049,1.998,0.28,2.792,0.998l12.956,11.748l31.089-32.559v0 c0.74-0.776,1.723-1.18,2.719-1.204c0.992-0.025,1.994,0.329,2.771,1.067v0.001c0.777,0.739,1.18,1.724,1.205,2.718 c0.025,0.993-0.33,1.997-1.068,2.773L55.279,81.769c-0.023,0.024-0.048,0.047-0.073,0.067c-0.715,0.715-1.649,1.095-2.598,1.13 c-0.974,0.037-1.963-0.293-2.744-1L34.118,67.688L34.106,67.678L34.106,67.678L34.106,67.678z'
          />
        </g>
      </svg>
    </>
  )
}

export const Iconadmintutorials = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <path
              d='M16.794 0L23 6.094v15.724C23 23.023 22.005 24 20.778 24H3.222C1.995 24 1 23.023 1 21.818V2.182C1 .977 1.995 0 3.222 0h13.572zM14.11 2.181H3.222v19.637h17.556l-.001-13.091h-4.444c-1.227 0-2.222-.977-2.222-2.182V2.181zm1.111 13.092v2.182H6.556v-2.182h8.666zm2.222-4.364v2.182H6.556v-2.182h10.888zm-1.111-8.276v3.912h3.984l-3.984-3.912z'
              transform='translate(-144 -2620) translate(88 2392) translate(56.883 228)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconawards = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <g>
              <path
                d='M18.87 0v.9c0 .28 0 .567-.004.856h4.193v.901c0 2.303-.614 4.25-1.876 5.951-1.07 1.443-2.415 2.456-3.602 3.35-.746.562-1.41 1.063-1.876 1.569-.903 1.194-2.017 2.232-3.32 3.091v1.487h.45c2.235 0 4.054 1.818 4.054 4.053v.9H6.08v-.9c0-2.235 1.818-4.053 4.053-4.053h.45v-1.487c-1.304-.86-2.42-1.9-3.324-3.098-.46-.502-1.112-.999-1.843-1.555-1.174-.895-2.505-1.909-3.564-3.353C.606 6.91 0 4.962 0 2.657v-.9h4.102C4.1 1.466 4.098 1.18 4.098.9V0H18.87zm-6.035 19.906h-2.702c-.921 0-1.715.557-2.064 1.351h6.83c-.348-.794-1.142-1.35-2.064-1.35zm4.228-18.105H5.905c.048 3.62.442 7.457 2.694 10.517.175.191.335.388.476.594.656.78 1.45 1.5 2.41 2.142.958-.642 1.753-1.362 2.412-2.14.136-.205.294-.4.467-.588 2.257-3.061 2.652-6.901 2.7-10.525zM11.507 4.19l.925 1.838 2.07.295-1.498 1.43.354 2.021-1.851-.954-1.851.954.353-2.02-1.497-1.431 2.07-.295.925-1.838zm9.71-.631h-2.4c-.088 1.761-.31 3.63-.87 5.478-.05.16-.1.32-.154.477 1.648-1.357 3.164-3.057 3.425-5.955zm-17.065 0H1.84c.254 2.869 1.717 4.565 3.322 5.913-.048-.144-.095-.289-.14-.435-.56-1.849-.783-3.717-.87-5.478z'
                transform='translate(-144 -2506) translate(88 2392) translate(56.883 114) translate(.5 1)'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconbidalerts = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <path
              d='M13.506.591c.248.231.43.506.546.802 3.185.922 5.648 3.994 5.648 8.421 0 2.862.585 4.473 1.667 5.645.268.29 1.21 1.132 1.316 1.238l.317.318v3.719l-6.739-.001-.06.215c-.307.984-.96 1.841-1.904 2.412-1.41.853-3.183.853-4.594 0-1.146-.693-1.78-1.468-2.006-2.626H1v-3.719l.317-.318c.114-.114 1.051-.948 1.318-1.235C3.715 14.296 4.3 12.686 4.3 9.814c0-4.44 2.46-7.505 5.65-8.423.114-.295.296-.57.544-.8.846-.788 2.166-.788 3.012 0zm.404 20.143l-3.913-.001.055.093c.16.242.412.44.797.673.707.427 1.595.427 2.302 0 .327-.198.582-.46.76-.765zM12 3.284c-2.934 0-5.5 2.408-5.5 6.53 0 3.4-.776 5.539-2.246 7.124-.23.249-.728.707-1.054 1.002v.613h17.6v-.613c-.328-.3-.824-.758-1.056-1.008-1.467-1.59-2.244-3.73-2.244-7.118 0-4.11-2.574-6.53-5.5-6.53zm0 10.89c.608 0 1.1.488 1.1 1.09 0 .603-.492 1.09-1.1 1.09-.607 0-1.1-.487-1.1-1.09 0-.602.493-1.09 1.1-1.09zm1.104-7.633v6.543h-2.2V6.54h2.2z'
              transform='translate(-88 -2677) translate(88 2392) translate(.883 285)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconcross = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <path
            fill='#2A324B'
            d='M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z'
            transform='translate(-1228 -1957) translate(1228 1957)'
          />
          <path
            fill='#FFF'
            d='M12 20.182c4.519 0 8.182-3.663 8.182-8.182S16.519 3.818 12 3.818 3.818 7.481 3.818 12 7.481 20.182 12 20.182z'
            transform='translate(-1228 -1957) translate(1228 1957)'
          />
          <path
            fill='#2A324B'
            d='M12 13.286L9.006 16.279 7.721 14.994 10.714 12 7.721 9.006 9.006 7.721 12 10.714 14.994 7.721 16.279 9.006 13.286 12 16.279 14.994 14.994 16.279z'
            transform='translate(-1228 -1957) translate(1228 1957)'
          />
        </g>
      </g>
    </g>
  </svg>
)

export const Icondirectory = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <path
            d='M22 1v17.6c-.614 0-1.111.492-1.111 1.1 0 .608.497 1.1 1.111 1.1V23H5.333C3.493 23 2 21.523 2 19.7V4.3C2 2.477 3.492 1 5.333 1H22zm-3.144 17.6H5.333c-.613 0-1.11.492-1.11 1.1 0 .608.497 1.1 1.11 1.1h13.523c-.122-.344-.19-.714-.19-1.1 0-.386.068-.756.19-1.1zM12 15c-3.169 0-5.181.542-5.798 1.4h11.596c-.617-.858-2.63-1.4-5.798-1.4zm7.778-11.8H5.333c-.613 0-1.11.492-1.11 1.1l-.001 11.491C5.013 13.827 7.868 13 12 13s6.987.827 7.778 2.791V3.2zM12 4c2.414 0 4 1.922 4 4.2 0 3.28-1.782 4.8-4 4.8-2.24 0-4-1.573-4-5 0-2.244 1.58-4 4-4zm0 2c-1.266 0-2 .816-2 2 0 2.27.818 3 2 3 1.178 0 2-.702 2-2.8 0-1.25-.784-2.2-2-2.2z'
            transform='translate(-73 -2294) translate(73.883 2294)'
          />
        </g>
      </g>
    </g>
  </svg>
)

export const Icondropdown = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#7E868F'>
        <g>
          <g>
            <g>
              <path
                d='M19.293 8.293L20.707 9.707 12 18.414 3.293 9.707 4.707 8.293 12 15.586z'
                transform='translate(-877 -457) translate(461 104) translate(67 323) translate(349 30)'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconevents = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <path
              d='M7.144 0v2.708h9.711V0h1.972l-.001 2.708H23.5V24H.5V2.708h4.673V0h1.971zm14.384 9.253H2.47v12.715h19.058V9.253zm-2.701 5.192v4.439h-4.308v-4.439h4.308zm-1.972 2.031h-.365v.376h.365v-.376zM21.528 4.74H2.471L2.47 7.222h19.058V4.739z'
              transform='translate(-88 -2563) translate(88 2392) translate(.883 171)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconfavorites = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <path
              d='M16.967 1C21.01 1.017 24 4.432 24 8.783c0 3.32-1.848 6.528-5.29 9.63-1.806 1.628-4.113 3.24-5.765 4.097L12 23l-.945-.49c-1.652-.858-3.959-2.469-5.765-4.097C1.848 15.311 0 12.103 0 8.783 0 4.386 2.963 1 7.041 1c1.523 0 2.593.206 3.783.796.414.205.803.449 1.165.73.376-.298.782-.553 1.214-.765C14.37 1.189 15.388 1 16.967 1zm-.004 2.186c-1.268 0-1.968.13-2.8.538-.514.252-.968.591-1.365 1.023l-.795.864-.803-.858c-.388-.414-.836-.746-1.343-.997-.859-.426-1.605-.57-2.816-.57-2.804 0-4.86 2.348-4.86 5.597 0 2.601 1.543 5.279 4.568 8.005 1.649 1.486 3.768 2.97 5.251 3.75 1.483-.78 3.602-2.264 5.251-3.75 3.025-2.726 4.567-5.404 4.567-8.005 0-3.204-2.085-5.585-4.855-5.597z'
              transform='translate(-144 -2449) translate(88 2392) translate(56.883 57)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconhome = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <path
            d='M13.557.644L24 11.069l-1.557 1.554-1.628-1.624V20.8c0 1.215-.986 2.2-2.203 2.2H5.388c-1.217 0-2.203-.985-2.203-2.2l-.001-9.801-1.627 1.624L0 11.069 10.443.644c.86-.859 2.254-.859 3.114 0zM12 2.199L5.388 8.8v12h13.224V8.799L12 2.199z'
            transform='translate(-70 -2015) translate(70.883 2015)'
          />
        </g>
      </g>
    </g>
  </svg>
)

export const Iconopportunities = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <path
              d='M22.505 6.843H17.79c-.484 0-.87.402-.87.905 0 .504.386.906.87.906h2.612l-5.66 5.887c-.58-.428-1.257-.73-1.982-.855V3.094l1.838 1.912c.169.176.387.277.604.277.218 0 .436-.1.605-.277.338-.352.338-.93 0-1.283L12.493.277C12.347.1 12.13 0 11.888 0s-.46.1-.605.277L7.946 3.723c-.339.352-.339.931 0 1.283.338.352.895.352 1.233 0l1.838-1.912v10.592c-.725.125-1.402.427-1.983.855l-5.66-5.887h2.613c.483 0 .87-.402.87-.906 0-.503-.387-.905-.87-.905H1.27c-.484 0-.871.402-.871.905v4.906c0 .503.387.906.87.906.484 0 .871-.403.871-.906V9.937l5.66 5.887c-.58.855-.895 1.862-.895 2.968C6.906 21.66 9.155 24 11.912 24s4.982-2.34 4.982-5.208c0-1.106-.338-2.138-.895-2.968l5.66-5.887v2.717c0 .503.387.906.87.906.484 0 .871-.403.871-.906V7.748c-.024-.503-.411-.905-.895-.905zM11.888 22.189c-1.79 0-3.265-1.51-3.265-3.397 0-1.861 1.451-3.396 3.265-3.396s3.265 1.51 3.265 3.396c0 1.862-1.475 3.397-3.265 3.397z'
              transform='translate(-88 -2506) translate(88 2392) translate(.883 114)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconsaved = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <path
              d='M21.9 20.8c0 1.215-.985 2.2-2.2 2.2H4.3c-1.215 0-2.2-.985-2.2-2.2h19.8zM15.3 1c1.215 0 2.2.985 2.2 2.2v7.7H23l-11 9.443L1 10.9h5.5V3.2c0-1.215.985-2.2 2.2-2.2h6.6zm0 2.2H8.7v9.9H7.274L12 17.446l4.726-4.346H15.3V3.2z'
              transform='translate(-144 -2392) translate(88 2392) translate(56.883)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Icontrackedopportunities = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <path
              d='M12 10.183c4.863 0 9.066 3.091 11.128 4.973.555.484.872 1.21.872 1.962 0 .753-.317 1.452-.872 1.963C21.066 20.909 16.863 24 12 24S2.934 20.909.872 19.027C.317 18.543 0 17.817 0 17.065c0-.753.317-1.452.872-1.963 2.062-1.828 6.265-4.92 11.128-4.92zm0 1.666c-2.855 0-5.18 2.34-5.18 5.242 0 2.904 2.325 5.27 5.18 5.27 2.855 0 5.18-2.366 5.18-5.27 0-2.903-2.325-5.242-5.18-5.242zm.37 1.29c.132 0 .238.108.238.243V14c.74.108 1.322.699 1.4 1.452.027.08 0 .134-.052.188-.053.054-.106.08-.185.08h-.714c-.105 0-.211-.08-.238-.188-.052-.188-.211-.322-.396-.322h-.634c-.344 0-.635.242-.661.564-.027.188.053.35.158.484.106.134.265.215.45.215h.528c.529 0 1.005.242 1.322.618.37.404.529.887.476 1.425-.08.78-.688 1.452-1.48 1.613v.672c0 .134-.106.242-.238.242h-.714c-.132 0-.238-.108-.238-.242v-.645c-.74-.108-1.322-.699-1.4-1.452-.027-.08 0-.134.052-.188.053-.054.106-.08.185-.08h.714c.105 0 .211.08.238.188.052.188.211.322.396.322h.634c.344 0 .635-.242.661-.564.027-.188-.053-.35-.158-.484-.106-.135-.265-.215-.45-.215h-.449c-.952 0-1.797-.726-1.877-1.667-.079-.968.555-1.828 1.48-1.99v-.644c0-.135.106-.242.238-.242zm5.18.108c.74 1.102 1.19 2.42 1.19 3.871 0 1.425-.45 2.77-1.19 3.871 1.93-.967 3.516-2.204 4.547-3.118.211-.215.344-.484.344-.726 0-.296-.133-.591-.344-.78-1.03-.913-2.617-2.177-4.546-3.118zm-11.1-.053c-1.93.967-3.516 2.204-4.547 3.118-.211.215-.344.484-.344.78 0 .295.133.564.344.725 1.03.914 2.617 2.178 4.546 3.118-.74-1.102-1.19-2.419-1.19-3.87 0-1.425.45-2.77 1.19-3.871zM21.525 2.769c.423-.135.846.107.978.537l.978 3.253c.106.403-.106.86-.529.995-.079.027-.158.027-.238.027-.317 0-.634-.215-.74-.565l-.423-1.398-2.748 5.242c-.133.269-.397.43-.688.43-.132 0-.264-.027-.37-.08-.37-.188-.528-.672-.317-1.076l2.723-5.268-1.375.43c-.423.134-.846-.108-.978-.538-.132-.43.106-.86.529-.995zm-20.03.537c.132-.43.555-.672.978-.537l3.198.994c.423.135.661.565.529.995-.132.43-.555.672-.978.538l-1.375-.43 2.723 5.268c.211.377.08.86-.317 1.076-.132.053-.238.08-.37.08-.265 0-.555-.161-.688-.43L2.448 5.618l-.423 1.398c-.08.35-.397.565-.74.565-.08 0-.159 0-.238-.027-.423-.135-.661-.565-.529-.995zM12 0c.211 0 .396.08.555.242l2.352 2.392c.318.323.318.807 0 1.13-.317.322-.792.322-1.11 0l-1.004-1.022v5.94c0 .458-.344.807-.793.807-.45 0-.793-.376-.793-.806V2.742l-1.004 1.021c-.159.162-.344.242-.555.242-.212 0-.397-.08-.555-.242-.318-.322-.318-.806 0-1.129L11.445.242C11.604.08 11.789 0 12 0z'
              transform='translate(-88 -2620) translate(88 2392) translate(.883 228)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconuser = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <path
            d='M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 14.545c-3.245 0-5.157.626-5.423 1.582C8.022 19.406 9.92 20.182 12 20.182s3.978-.776 5.422-2.054c-.265-.957-2.177-1.583-5.422-1.583zm0-12.727c-4.519 0-8.182 3.663-8.182 8.182 0 1.731.538 3.337 1.455 4.659 1.024-1.352 3.428-1.932 6.727-1.932 3.299 0 5.703.58 6.726 1.931.918-1.321 1.456-2.927 1.456-4.658 0-4.519-3.663-8.182-8.182-8.182zm0 2.727c2.195 0 3.636 1.747 3.636 3.819 0 2.981-1.62 4.363-3.636 4.363-2.036 0-3.636-1.43-3.636-4.545 0-2.04 1.435-3.637 3.636-3.637zm0 1.819c-1.151 0-1.818.741-1.818 1.818 0 2.063.744 2.727 1.818 2.727 1.07 0 1.818-.638 1.818-2.545 0-1.136-.713-2-1.818-2z'
            transform='translate(-1193 -1957) translate(1193 1957)'
          />
        </g>
      </g>
    </g>
  </svg>
)

export const TabularviewIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#7E868F'>
          <g>
            <path
              d='M5.455 20C4.65 20 4 19.306 4 18.45V5.55C4 4.694 4.651 4 5.455 4h13.09C19.35 4 20 4.694 20 5.55v12.9c0 .856-.651 1.55-1.455 1.55H5.455zm2.908-4.817H5.454v3.267l2.909-.001v-3.266zm10.182 0H9.818v3.266h8.727v-3.266zM8.363 10.366H5.454v3.267h2.909v-3.267zm10.182 0H9.818v3.267h8.727v-3.267zM8.363 5.55H5.455l-.001 3.266h2.909V5.55zm10.182 0H9.818v3.266h8.727V5.55z'
              transform='translate(-1645 -2056) translate(1645 2056)'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Boardview = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='25'
      viewBox='0 0 24 25'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#7E868F'>
          <g>
            <g>
              <path
                d='M18.4 4c.884 0 1.6.716 1.6 1.6v12.8c0 .884-.716 1.6-1.6 1.6H5.6c-.884 0-1.6-.716-1.6-1.6V5.6C4 4.716 4.716 4 5.6 4h12.8zm-7.2 6.4H5.6v8h5.6v-8zm1.6 8h5.6v-3.2h-5.6v3.2zm5.6-12.8l-5.6-.001V13.6h5.6v-8zm-7.2 3.2V5.599L5.6 5.6v3.2h5.6z'
                transform='translate(-1683 -2056) translate(1683 2056) translate(0 .313)'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Calendarview = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#7E868F'>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d='M8.8 4v.8h6.4V4h1.6l-.001.8H18.4c.884 0 1.6.716 1.6 1.6v12c0 .884-.716 1.6-1.6 1.6H5.6c-.884 0-1.6-.716-1.6-1.6v-12c0-.884.716-1.6 1.6-1.6h1.6V4h1.6zm9.6 6.4H5.599l.001 8h12.8v-8zm-11.2-4H5.6l-.001 2.4H18.4V6.4h-1.601l.001.8h-1.6v-.8H8.8v.8H7.2v-.8z'
                    transform='translate(-985 -98) translate(75 81) translate(730 13) translate(176) translate(4 4)'
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Listview = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#7E868F'>
          <g>
            <path
              d='M5.6 15.75c.884 0 1.6.728 1.6 1.625S6.484 19 5.6 19c-.884 0-1.6-.728-1.6-1.625s.716-1.625 1.6-1.625zm14.4.813v1.625H8.8v-1.625H20zM5.6 10.875c.884 0 1.6.728 1.6 1.625s-.716 1.625-1.6 1.625c-.884 0-1.6-.728-1.6-1.625s.716-1.625 1.6-1.625zm14.4.813v1.624H8.8v-1.624H20zM5.6 6c.884 0 1.6.728 1.6 1.625S6.484 9.25 5.6 9.25c-.884 0-1.6-.728-1.6-1.625S4.716 6 5.6 6zm14.4.813v1.625H8.8V6.812H20z'
              transform='translate(-1607 -2056) translate(1607 2056)'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
export const BidBoardLeftSideBar = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <path
            d='M20.4 2c1.16 0 2.1.94 2.1 2.1v16.8c0 1.16-.94 2.1-2.1 2.1H3.6c-1.16 0-2.1-.94-2.1-2.1V4.1c0-1.16.94-2.1 2.1-2.1h16.8zm-9.45 2.099L3.6 4.1v16.8h7.35V10.4H3.6V8.3h7.35V4.099zm2.1 16.801h7.35v-4.2h-7.35v4.2zM20.4 4.1l-7.35-.001V14.6h7.35V4.1z'
            transform='translate(-71 -2217) translate(71.883 2217)'
          />
        </g>
      </g>
    </g>
  </svg>
)
export const Iconpin = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B' fillRule='nonzero' stroke='#2A324B' strokeWidth='.3'>
        <g>
          <g>
            <path
              d='M21.353 6.997l-6.75-6.75C14.445.09 14.23 0 14.006 0c-.223 0-.438.089-.596.247-.39.39-.58 1.087-.868 2.14-.336 1.236-.797 2.928-1.607 3.738-.523.523-1.651.568-2.845.615-1.543.061-3.291.13-4.468 1.307-.33.33-.33.864 0 1.194l3.812 3.811L.25 20.156c-.33.328-.334.862-.006 1.194.165.166.382.25.6.25.214 0 .429-.081.593-.244l7.19-7.11 3.733 3.732c.164.165.38.247.596.247.216 0 .432-.082.597-.247 1.056-1.056 1.215-2.56 1.282-3.887.023-.466-.335-.862-.8-.885-.466-.024-.862.335-.886.8-.04.817-.122 1.506-.33 2.045L5.55 8.782c.726-.281 1.678-.319 2.607-.356 1.465-.058 2.981-.118 3.97-1.108 1.128-1.127 1.657-3.069 2.044-4.487.042-.154.088-.325.136-.494l4.956 4.956c-.17.048-.34.094-.494.136-1.418.387-3.36.916-4.487 2.043-.33.33-.33.864 0 1.193.33.33.863.33 1.193 0 .81-.81 2.502-1.27 3.738-1.607 1.053-.287 1.75-.477 2.14-.868.158-.158.247-.372.247-.596 0-.224-.089-.439-.247-.597z'
              transform='translate(-719 -2634) translate(719 2634) translate(1 1)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconedit = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <path
            d='M16.437 2c.655 0 1.283.261 1.741.723l3.101 3.101c.462.462.721 1.088.721 1.741s-.26 1.28-.721 1.74L9.958 20.625c-.699.805-1.69 1.3-2.823 1.378H2v-1l.003-4.215c.085-1.054.576-2.035 1.323-2.694l11.37-11.368C15.155 2.26 15.782 2 16.436 2zm-4.135 5.945L4.696 15.55c-.405.358-.656.86-.696 1.318v3.135l3.064.002c.534-.038 1.031-.287 1.43-.743l7.562-7.563-3.754-3.754zM16.437 4c-.121 0-.238.049-.323.135L13.716 6.53l3.754 3.754 2.395-2.393c.086-.087.135-.204.135-.327 0-.122-.049-.24-.135-.326L16.76 4.135C16.675 4.049 16.56 4 16.437 4z'
            transform='translate(-751 -2635) translate(751 2635)'
          />
        </g>
      </g>
    </g>
  </svg>
)

export const Icondelete = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B'>
        <g>
          <g>
            <path
              d='M11.7 0c.994 0 1.8.806 1.8 1.8v.9h2.7c.994 0 1.8.806 1.8 1.8v1.8c0 .994-.806 1.8-1.8 1.8h-.073L15.3 18c0 .994-.806 1.8-1.8 1.8h-9c-.994 0-1.8-.806-1.797-1.725L1.871 8.1H1.8C.806 8.1 0 7.294 0 6.3V4.5c0-.994.806-1.8 1.8-1.8h2.7v-.9C4.5.806 5.306 0 6.3 0h5.4zm2.621 8.1H3.677L4.5 18h9l.003-.075.818-9.825zM16.2 4.5H1.8v1.8h14.4V4.5zm-4.5-2.7H6.3v.9h5.4v-.9z'
              transform='translate(-783 -2635) translate(783 2635) translate(3 2)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export function Iconupload() {
  return (
    <svg
      width='24px'
      height='24px'
      viewBox='0 0 24 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <title>C0DFE871-F7C3-4028-B8E2-CE5E66CDA1A9</title>
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g
          id='GovGenie_my-profile_Edit-Profile'
          transform='translate(-560.000000, -344.000000)'
          fill='#7E868F'
          fillRule='nonzero'
        >
          <g id='Group-6' transform='translate(520.000000, 224.000000)'>
            <g id='Group-8' transform='translate(40.000000, 119.000000)'>
              <g
                id='Icons/Upload-image'
                transform='translate(0.000000, 1.000000)'
              >
                <g id='upload-(1)' transform='translate(4.000000, 4.000000)'>
                  <path
                    d='M5.46417241,4.53382326 L7.17241379,2.82558188 L7.17241379,11.8620991 C7.17241379,12.3191624 7.54293676,12.6896853 8,12.6896853 C8.45706324,12.6896853 8.82758621,12.3191624 8.82758621,11.8620991 L8.82758621,2.82558188 L10.5358276,4.53382326 C10.7447052,4.74384002 11.0498983,4.82620958 11.336079,4.74980568 C11.6222596,4.67340178 11.8457854,4.44987595 11.9221893,4.16369533 C11.9985932,3.87751471 11.9162237,3.57232158 11.7062069,3.36344395 L8.5852069,0.242409466 C8.43000315,0.0871977221 8.2194969,0 8,0 C7.7805031,0 7.56999685,0.0871977221 7.4147931,0.242409466 L4.2937931,3.36344395 C4.08377634,3.57232158 4.00140679,3.87751471 4.07781069,4.16369533 C4.15421458,4.44987595 4.37774041,4.67340178 4.66392103,4.74980568 C4.95010166,4.82620958 5.25529478,4.74384002 5.46417241,4.53382326 L5.46417241,4.53382326 Z'
                    id='Path'
                  ></path>
                  <path
                    d='M15.1724138,7.17244395 C14.7153506,7.17244395 14.3448276,7.54296691 14.3448276,8.00003016 L14.3448276,14.3448577 L1.65517241,14.3448577 L1.65517241,8.00003016 C1.65517241,7.54296691 1.28464945,7.17244395 0.827586207,7.17244395 C0.370522966,7.17244395 9.80058946e-16,7.54296691 9.80058946e-16,8.00003016 L9.80058946e-16,14.6207198 C9.80058946e-16,15.3824919 0.617538276,16.0000302 1.37931034,16.0000302 L14.6206897,16.0000302 C15.3824617,16.0000302 16,15.3824919 16,14.6207198 L16,8.00003016 C16,7.54296691 15.629477,7.17244395 15.1724138,7.17244395 L15.1724138,7.17244395 Z'
                    id='Path'
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Icondocument = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <defs>
      <filter id='noyiqzi7va'>
        <feColorMatrix
          in='SourceGraphic'
          values='0 0 0 0 0.325490 0 0 0 0 0.764706 0 0 0 0 0.741176 0 0 0 1.000000 0'
        />
      </filter>
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <g>
            <g>
              <g
                filter='url(#noyiqzi7va)'
                transform='translate(-1292 -155) translate(75 81) translate(1175 13) translate(42 61) translate(.5)'
              >
                <g fill='#000' fillRule='nonzero'>
                  <path
                    d='M19.282 4.718l-4.5-4.5c-.141-.14-.333-.22-.532-.218h-12C1.007 0 0 1.007 0 2.25v19.5C0 22.993 1.007 24 2.25 24h15c1.243 0 2.25-1.007 2.25-2.25V5.25c.001-.2-.077-.39-.218-.532zM18 21.75c0 .414-.336.75-.75.75h-15c-.414 0-.75-.336-.75-.75V2.25c0-.414.336-.75.75-.75H13.5v3c0 .828.672 1.5 1.5 1.5h3v15.75z'
                    transform='translate(2)'
                  />
                  <path
                    d='M15 18H16.5V19.5H15zM3 10.5H16.5V12H3zM3 14.25H16.5V15.75H3zM3 18H13.5V19.5H3z'
                    transform='translate(2)'
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconspluseadd = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#53C3BD'>
        <g>
          <path
            d='M13 11L20 11 20 13 13 13 13 20 11 20 11 13 4 13 4 11 11 11 11 4 13 4z'
            transform='translate(-1771 -1933) translate(1771 1933)'
          />
        </g>
      </g>
    </g>
  </svg>
)

export const Iconsearch = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#7E868F'>
        <g>
          <g>
            <g>
              <path
                d='M13.55 11.854c-.236-.236-.875-.47-1.918-.702 1.079-1.182 1.73-2.758 1.73-4.471C13.362 2.998 10.364 0 6.68 0S0 2.998 0 6.68c0 3.684 2.998 6.682 6.68 6.682 1.714 0 3.29-.651 4.472-1.73.217 1.016.451 1.656.702 1.918l2.09 2.09c.24.24.549.36.857.36.308 0 .617-.12.856-.36.463-.462.463-1.233 0-1.696l-2.107-2.09zm-6.87.137c-2.928 0-5.31-2.38-5.31-5.31 0-2.93 2.382-5.31 5.31-5.31 2.93 0 5.311 2.38 5.311 5.31 0 2.93-2.38 5.31-5.31 5.31z'
                transform='translate(-327 -205) translate(302 81) translate(16 116) translate(9 8)'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconsdeselect = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd' opacity='.2'>
      <g>
        <g>
          <g>
            <g>
              <g transform='translate(-915 -529) translate(419 224) translate(61 179) translate(435 126) translate(1.5 1.5)'>
                <circle cx='10.5' cy='10.5' r='10.5' fill='#2A324B' />
                <path
                  stroke='#FFF'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                  strokeWidth='1.5'
                  d='M6.6 11.055L9.25 13.781 14.601 7.67'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const Iconscancel = () => (
  <svg width='12' height='12' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.95 1.05a.875.875 0 0 1 0 1.238L7.237 6l3.713 3.712a.875.875 0 0 1-1.238 1.238L6.001 7.237 2.288 10.95A.875.875 0 0 1 1.05 9.712L4.763 6 1.05 2.288A.875.875 0 0 1 2.288 1.05L6 4.763 9.712 1.05a.875.875 0 0 1 1.238 0z'
      fill='#7E868F'
      stroke='#7E868F'
      fill-rule='evenodd'
    />
  </svg>
)

export const IconTeamingPortal = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    height='24'
    viewBox='0 0 25 24'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#2A324B' stroke='#2A324B' strokeWidth='.3'>
        <g>
          <g>
            <g>
              <path
                d='M8 0C5.36-.001 3.2 2.159 3.2 4.8c.001 1.245.485 2.391 1.281 3.251L1.955 9.733c-.165.11-.283.279-.33.472L.024 16.607c-.125.504.257.992.777.992h2.975l-.552 2.207c-.125.504.256.993.776.993h16c.52 0 .901-.489.776-.993l-.552-2.207H23.2c.52 0 .901-.488.776-.992l-1.6-6.402c-.048-.194-.168-.362-.334-.472L19.518 8.05c.795-.86 1.28-2.005 1.281-3.25C20.8 2.16 18.64 0 15.999.001c-1.38 0-2.68.6-3.584 1.62-.138-.01-.275-.02-.415-.02-.14 0-.278.01-.416.02C10.681.602 9.38.002 8.001 0zm0 1.6c.612 0 1.2.18 1.705.5-1.944.88-3.306 2.834-3.306 5.099 0 .127.01.252.02.377C5.442 7.024 4.8 5.983 4.8 4.8 4.8 3.023 6.223 1.6 8 1.6h0zM16 1.6c1.777 0 3.199 1.423 3.198 3.2 0 1.184-.644 2.226-1.62 2.779.008-.126.02-.252.02-.38 0-2.265-1.36-4.22-3.304-5.099.505-.32 1.094-.499 1.706-.5h0zM12 3.202c2.219 0 4.001 1.78 4.001 3.998 0 2.219-1.782 4.001-4.001 4.001-2.219 0-4-1.782-4-4.001C8 4.98 9.78 3.201 12 3.201zM5.818 9.065c.334.17.69.307 1.064.396.326.732.804 1.38 1.394 1.907l-3.034 1.516c-.208.105-.361.295-.418.522l-.647 2.592H1.825l1.276-5.105 2.717-1.828zm12.36.003l2.722 1.825L22.175 16h-2.352l-.647-2.592c-.057-.227-.21-.418-.418-.522l-3.034-1.517c.589-.528 1.067-1.174 1.391-1.905.374-.09.73-.225 1.062-.395h0zM9.85 12.369c.663.277 1.388.432 2.149.432.761 0 1.487-.154 2.15-.432l3.563 1.782 1.263 5.05H5.024l1.263-5.05 3.564-1.782z'
                transform='translate(-71 -2335) translate(71.883 2335) translate(0 1) translate(0 .278)'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const IconDocument = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <defs>
      <filter id='zykn76a1ka'>
        <feColorMatrix
          in='SourceGraphic'
          values='0 0 0 0 0.164706 0 0 0 0 0.196078 0 0 0 0 0.294118 0 0 0 1.000000 0'
        />
      </filter>
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <g
            filter='url(#zykn76a1ka)'
            transform='translate(-91 -306) translate(75 181) translate(16 125)'
          >
            <g fill='#000' fillRule='nonzero'>
              <path
                d='M19.282 4.718l-4.5-4.5c-.141-.14-.333-.22-.532-.218h-12C1.007 0 0 1.007 0 2.25v19.5C0 22.993 1.007 24 2.25 24h15c1.243 0 2.25-1.007 2.25-2.25V5.25c.001-.2-.077-.39-.218-.532zM18 21.75c0 .414-.336.75-.75.75h-15c-.414 0-.75-.336-.75-.75V2.25c0-.414.336-.75.75-.75H13.5v3c0 .828.672 1.5 1.5 1.5h3v15.75z'
                transform='translate(2)'
              />
              <path
                d='M15 18H16.5V19.5H15zM3 10.5H16.5V12H3zM3 14.25H16.5V15.75H3zM3 18H13.5V19.5H3z'
                transform='translate(2)'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
export function AddToTeamIconGreen() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width='30'
      height='30'
      viewBox='0 0 30 30'
    >
      <defs>
        <circle id='myzz6ixema' cx='15' cy='15' r='13.5'></circle>
        <mask
          id='8mhrsrpxgb'
          width='27'
          height='27'
          x='0'
          y='0'
          fill='#fff'
          maskContentUnits='userSpaceOnUse'
          maskUnits='objectBoundingBox'
        >
          <use xlinkHref='#myzz6ixema'></use>
        </mask>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <use
          fill='#EFFFF7'
          stroke='#39CD85'
          strokeDasharray='1.8 1.8'
          strokeWidth='1.8'
          mask='url(#8mhrsrpxgb)'
          xlinkHref='#myzz6ixema'
        ></use>
        <path
          fill='#39CD85'
          d='M20.64 15.64h-5v5H14v-5H9V14h5V9h1.64v5h5z'
        ></path>
      </g>
    </svg>
  )
}

export function AddToTeamIconGrey() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width='30'
      height='30'
      viewBox='0 0 30 30'
    >
      <defs>
        <circle id='nuimh43x1a' cx='15' cy='15' r='13.5'></circle>
        <mask
          id='93zcysb3xb'
          width='27'
          height='27'
          x='0'
          y='0'
          fill='#fff'
          maskContentUnits='userSpaceOnUse'
          maskUnits='objectBoundingBox'
        >
          <use xlinkHref='#nuimh43x1a'></use>
        </mask>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <use
          fill='#E9E8E8'
          stroke='#656565'
          strokeDasharray='1.8 1.8'
          strokeWidth='1.8'
          mask='url(#93zcysb3xb)'
          xlinkHref='#nuimh43x1a'
        ></use>
        <path
          fill='#656565'
          d='M20.64 15.64h-5v5H14v-5H9V14h5V9h1.64v5h5z'
        ></path>
      </g>
    </svg>
  )
}

export const IconArchivedLeftSideBar = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='24'
      viewBox='0 0 25 24'
    >
      <path
        fill='#2A324B'
        fillRule='evenodd'
        d='M18.883 1l.157.01c.903.12 1.565.781 2.146 1.917l3.697 8.627V20.2a2.4 2.4 0 01-2.4 2.4h-19.2a2.4 2.4 0 01-2.4-2.4v-8.646l.097-.227 3.626-8.456C5.146 1.77 5.829 1.088 6.883 1h12zm-15.6 19.2h19.2v-7.201l-4.8.001a2.4 2.4 0 01-2.4 2.4h-4.8a2.4 2.4 0 01-2.4-2.4l-4.8-.001V20.2zM7.094 3.395c-.093.1-.207.275-.308.478l-2.883 6.726 6.58.001V13h4.8v-2.4l6.58-.001-2.847-6.65a2.48 2.48 0 00-.359-.55L7.094 3.396z'
      ></path>
    </svg>
  )
}

export function IconPinnedTeam() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path
        fill='#F44336'
        fillRule='nonzero'
        stroke='#F44336'
        strokeWidth='0.3'
        d='M22.353 7.997l-6.75-6.75a.844.844 0 00-1.193 0c-.39.39-.58 1.087-.868 2.14-.336 1.236-.797 2.928-1.607 3.738-.523.523-1.651.568-2.845.615-1.543.061-3.291.13-4.468 1.307a.844.844 0 000 1.194l3.812 3.811-7.184 7.104a.846.846 0 00.594 1.444.839.839 0 00.593-.244l7.19-7.11 3.733 3.732a.841.841 0 001.193 0c1.056-1.056 1.215-2.56 1.282-3.887a.843.843 0 10-1.686-.085c-.04.817-.122 1.506-.33 2.045L6.55 9.782c.726-.281 1.678-.319 2.607-.356 1.465-.058 2.981-.118 3.97-1.108 1.128-1.127 1.657-3.069 2.044-4.487.042-.154.088-.325.136-.494l4.956 4.956c-.17.048-.34.094-.494.136-1.418.387-3.36.916-4.487 2.043a.843.843 0 101.193 1.193c.81-.81 2.502-1.27 3.738-1.607 1.053-.287 1.75-.477 2.14-.868a.842.842 0 000-1.193z'
      ></path>
    </svg>
  )
}

export function Iconattach() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#7E868F'>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d='M9.054 4.18l1.012.983-4.486 4.49c-.225.227-.225.592 0 .818.213.215.57.214.781 0l4.936-4.944c.72-.725.72-1.889 0-2.614-.687-.692-1.904-.676-2.577.001L3.332 8.306c-1.216 1.223-1.216 3.187 0 4.41 1.181 1.188 3.21 1.169 4.373 0l6.283-6.292L15 7.406l-6.282 6.29c-1.714 1.724-4.658 1.753-6.4 0C.56 11.93.56 9.093 2.32 7.325l5.388-5.392c1.223-1.23 3.354-1.257 4.605 0 1.261 1.27 1.261 3.305-.002 4.575l-4.932 4.94c-.764.777-2.04.78-2.813.003-.766-.77-.766-2.006.002-2.778L9.054 4.18z'
                    transform='translate(-654 -1697) translate(75 181) translate(15 1347) translate(43) translate(521 169)'
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
export function Lock() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path
        fill='#7E868F'
        fillRule='evenodd'
        d='M12 5a3.75 3.75 0 013.75 3.75v2.249l.75.001c.801 0 1.5.582 1.5 1.375v6.25c0 .793-.699 1.375-1.5 1.375h-9c-.801 0-1.5-.582-1.5-1.375v-6.25C6 11.582 6.699 11 7.5 11l.75-.001V8.75A3.75 3.75 0 0112 5zm4.5 7.5h-9v6h9v-6zM12 14.75a.75.75 0 110 1.5.75.75 0 010-1.5zm0-8.25a2.25 2.25 0 00-2.25 2.25v2.249h4.5V8.75A2.25 2.25 0 0012 6.5z'
      ></path>
    </svg>
  )
}

export function AddIconPurple() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width='30'
      height='30'
      viewBox='0 0 30 30'
    >
      <defs>
        <circle id='dhvwdsfcxa' cx='15' cy='15' r='13.5'></circle>
        <mask
          id='tdba0ld08b'
          width='27'
          height='27'
          x='0'
          y='0'
          fill='#fff'
          maskContentUnits='userSpaceOnUse'
          maskUnits='objectBoundingBox'
        >
          <use xlinkHref='#dhvwdsfcxa'></use>
        </mask>
      </defs>
      <g fill='none' fillRule='evenodd'>
        <use
          fill='#F1F1FF'
          stroke='#9895E0'
          strokeDasharray='1.8 1.8'
          strokeWidth='1.8'
          mask='url(#tdba0ld08b)'
          xlinkHref='#dhvwdsfcxa'
        ></use>
        <path
          fill='#9895E0'
          d='M20.64 15.64h-5v5H14v-5H9V14h5V9h1.64v5h5z'
        ></path>
      </g>
    </svg>
  )
}

export function WebsiteLogo() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='116'
      height='33'
      viewBox='0 0 116 33'
    >
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#53C3BD'
          fillRule='nonzero'
          d='M23.945 8.33c-2.06 0-3.731.678-5.016 2.032-1.284 1.355-1.927 3.063-1.927 5.123s.638 3.763 1.914 5.11c1.275 1.345 2.952 2.018 5.029 2.018 2.096 0 3.786-.673 5.07-2.019 1.285-1.346 1.927-3.049 1.927-5.109 0-2.041-.651-3.745-1.954-5.109-1.303-1.364-2.984-2.046-5.043-2.046zm0 2.645c1.203 0 2.196.441 2.98 1.323.783.881 1.175 1.944 1.175 3.187 0 1.263-.378 2.32-1.135 3.174-.756.854-1.763 1.28-3.02 1.28-1.257 0-2.26-.426-3.007-1.28-.747-.853-1.12-1.911-1.12-3.174 0-1.262.378-2.33 1.134-3.201.756-.873 1.754-1.309 2.993-1.309zm19.434-2.394l-2.022 4.983-2.133 5.819-2.377-6.375-1.805-4.427h-3.115l5.74 13.809h3.088l5.713-13.809z'
        ></path>
        <path
          fill='#000'
          fillRule='nonzero'
          d='M78.175 16.543c.256-2.71-.246-4.77-1.503-6.18-1.257-1.411-3.016-2.116-5.275-2.116-2.096 0-3.8.668-5.112 2.004-1.312 1.336-1.968 3.053-1.968 5.15 0 2.21.66 3.973 1.982 5.29 1.321 1.319 3.084 1.977 5.289 1.977a8.785 8.785 0 003.212-.612c1.047-.409 1.909-.984 2.583-1.727l-1.832-1.81c-.4.446-.97.803-1.709 1.072a6.366 6.366 0 01-2.2.404c-1.22 0-2.227-.316-3.02-.947-.793-.63-1.253-1.466-1.38-2.505h10.933zm-10.878-2.422c.218-1.058.706-1.874 1.462-2.45.756-.575 1.662-.863 2.72-.863 1.148 0 2.081.288 2.801.863.72.576 1.116 1.392 1.19 2.45h-8.173zm26.814 8.213v-7.378c0-2.041-.542-3.647-1.626-4.816-1.085-1.17-2.474-1.754-4.169-1.754-1.75 0-3.262.733-4.537 2.2l-.164-2.005h-2.57v13.753h2.816V15.15c0-1.15.355-2.125 1.066-2.923.711-.798 1.613-1.198 2.706-1.198 1.149 0 2.041.358 2.68 1.072.637.715.956 1.675.956 2.882v7.35h2.842zm5.664-13.781v13.781h-2.816V8.554h2.816zm-3.143-3.981c0 .742.291 1.266.874 1.573.583.306 1.167.306 1.75 0 .583-.307.875-.83.875-1.573 0-.742-.292-1.262-.875-1.56a1.835 1.835 0 00-1.75 0c-.583.298-.874.817-.874 1.56zm19.248 11.971c.256-2.71-.246-4.77-1.503-6.18-1.257-1.411-3.016-2.116-5.275-2.116-2.096 0-3.8.668-5.112 2.004-1.312 1.336-1.968 3.053-1.968 5.15 0 2.21.66 3.973 1.982 5.29 1.321 1.319 3.084 1.977 5.289 1.977a8.785 8.785 0 003.212-.612c1.047-.409 1.908-.984 2.583-1.727l-1.832-1.81c-.4.446-.97.803-1.708 1.072a6.37 6.37 0 01-2.2.404c-1.222 0-2.228-.316-3.021-.947-.793-.63-1.253-1.466-1.38-2.505h10.933zm-10.879-2.422c.219-1.058.706-1.874 1.462-2.45.756-.575 1.663-.863 2.72-.863 1.148 0 2.082.288 2.802.863.72.576 1.116 1.392 1.19 2.45h-8.174z'
        ></path>
        <path
          fill='#53C3BD'
          d='M4.852 11.595c-.868-.602-1.324-1.428-1.368-2.476-.446.253-.867.55-1.261.884C.67 11.312.022 13.088.022 15.118c0 1.958.56 3.742 2.003 5.078 1.455 1.347 3.3 1.84 5.235 1.84 1.057 0 2.134.192 3.04.77.744.474 1.121 1.128 1.121 2.024 0 .912-.358 1.58-1.143 2.027-3.506 1.996-7.449.852-9.38-2.723l-.69-1.278-.028 1.458c-.036 1.782.56 3.318 1.942 4.446 1.453 1.186 3.256 1.597 5.086 1.597 1.785 0 3.5-.41 4.994-1.43 1.432-.98 2.166-2.365 2.166-4.124 0-2.177-1.13-3.55-2.897-4.333a5.13 5.13 0 001.982-1.837c.671-1.068.993-2.248.993-3.515 0-2.146-1.142-4.293-2.849-5.598-1.204-.92-2.36-1.046-3.774-1.27-.623-.098-.954-.47-.226-1.35.252-.304.55-.617.855-.867l1.35-1.107c-1.977.498-5.245 1.37-5.036 4.092.065.842.481 1.451 1.358 1.76 1.549.544 2.788.052 4.209 1.293.91.795 1.245 1.874 1.245 3.074 0 1.164-.387 2.153-1.2 2.973-.85.858-1.904 1.212-3.092 1.212-1.17 0-2.25-.31-3.135-1.107-.899-.808-1.222-1.913-1.236-3.108 0-1.202.346-2.27 1.279-3.053.208-.174.427-.33.658-.467z'
        ></path>
        <path
          fill='#000'
          fillRule='nonzero'
          d='M51.788 11.595c-.868-.602-1.325-1.428-1.369-2.476-.446.253-.867.55-1.261.884-1.553 1.309-2.201 3.085-2.201 5.115 0 1.958.56 3.742 2.003 5.078 1.455 1.347 3.3 1.84 5.235 1.84 1.057 0 2.134.192 3.04.77.743.474 1.121 1.128 1.121 2.024 0 .912-.358 1.58-1.143 2.027-3.506 1.996-7.448.852-9.38-2.723l-.69-1.278-.029 1.458c-.035 1.782.561 3.318 1.943 4.446 1.453 1.186 3.256 1.597 5.086 1.597 1.786 0 3.5-.41 4.994-1.43 1.433-.98 2.166-2.365 2.166-4.124 0-2.177-1.13-3.55-2.897-4.333a5.133 5.133 0 001.983-1.837c.671-1.068.992-2.248.992-3.515 0-2.146-1.142-4.293-2.848-5.598-1.204-.92-2.36-1.046-3.774-1.27-.623-.098-.955-.47-.226-1.35.252-.304.55-.617.854-.867l1.352-1.107c-1.977.498-5.245 1.37-5.036 4.092.064.842.481 1.451 1.357 1.76 1.55.544 2.789.052 4.209 1.293.91.795 1.245 1.874 1.245 3.074 0 1.164-.387 2.153-1.2 2.973-.85.858-1.904 1.212-3.092 1.212-1.17 0-2.25-.31-3.135-1.107-.899-.808-1.222-1.913-1.236-3.108 0-1.202.346-2.27 1.279-3.053.208-.174.427-.33.658-.467z'
        ></path>
      </g>
    </svg>
  )
}

export function IconSetting() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path
        fill='#7E868F'
        fillRule='evenodd'
        d='M8.8 12.778c1.767 0 3.2 1.393 3.2 3.11C12 17.609 10.567 19 8.8 19c-1.491 0-2.744-.991-3.1-2.333H4V15.11h1.7c.356-1.342 1.609-2.333 3.1-2.333zm0 1.555c-.884 0-1.6.697-1.6 1.556 0 .859.716 1.555 1.6 1.555.884 0 1.6-.696 1.6-1.555 0-.86-.716-1.556-1.6-1.556zm11.2.778v1.556h-6.4V15.11H20zM12.8 5C14.567 5 16 6.393 16 8.111c0 1.718-1.433 3.111-3.2 3.111-1.491 0-2.744-.991-3.1-2.333H4V7.333h5.7C10.057 5.991 11.31 5 12.8 5zm0 1.556c-.884 0-1.6.696-1.6 1.555 0 .86.716 1.556 1.6 1.556.884 0 1.6-.697 1.6-1.556 0-.859-.716-1.555-1.6-1.555zm7.2.777V8.89h-2.4V7.333H20z'
      ></path>
    </svg>
  )
}

export function CameraImage() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='35'
      height='35'
      viewBox='0 0 35 35'
    >
      <g fill='none' fillRule='evenodd'>
        <circle cx='17.5' cy='17.5' r='17.5' fill='#2A324B'></circle>
        <path
          fill='#FFF'
          d='M19.111 10c.845 0 1.314.484 1.959 1.539.026.042.185.306.23.377.077.127.138.22.193.297.037.05.069.09.094.12h2.19a2.333 2.333 0 012.334 2.334v7A2.334 2.334 0 0123.778 24H11.333A2.334 2.334 0 019 21.667v-7a2.334 2.334 0 012.333-2.334h2.19c.027-.03.058-.07.095-.12a5.12 5.12 0 00.194-.297c.044-.07.203-.335.23-.377C14.685 10.484 15.154 10 16 10h3.111zm0 1.556H16c-.067 0-.28.219-.631.794l-.233.383a6.12 6.12 0 01-.256.388c-.348.485-.697.768-1.213.768h-2.334a.777.777 0 00-.777.778v7c0 .43.348.777.777.777h12.445c.43 0 .778-.348.778-.777v-7a.778.778 0 00-.778-.778h-2.334c-.516 0-.865-.283-1.213-.768a6.588 6.588 0 01-.256-.388l-.232-.383c-.352-.575-.564-.794-.632-.794zM23 16.222a.778.778 0 100-1.555.778.778 0 000 1.555zm-5.444-2.333a3.889 3.889 0 11-.001 7.777 3.889 3.889 0 01.001-7.777zm0 1.555a2.333 2.333 0 10-.001 4.667 2.333 2.333 0 00.001-4.667z'
        ></path>
      </g>
    </svg>
  )
}

export const LinkIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#FFF' fillRule='nonzero'>
        <g>
          <g>
            <g>
              <path
                d='M6.892 5.38c.444.359.879.82 1.165 1.406.045.093.012.203-.077.255-.333.193-.633.476-.835.852-.157.265-.311.768-.211 1.309.094.717.818 1.374 1.393 1.967l1.998 2.04c.8.816 2.124.83 2.94.03.818-.801.831-2.124.03-2.941l-1.22-1.255c-.055-.057-.074-.14-.05-.215.272-.832.346-1.951.175-2.816-.005-.024.025-.04.042-.022l2.55 2.603c1.672 1.706 1.658 4.483-.03 6.172-1.706 1.671-4.47 1.643-6.14-.063-.152-.17-.433-.451-.771-.788l-.54-.54c-.88-.88-1.872-1.905-2.055-2.344l-.005-.002c-.528-.966-.632-2.075-.384-3.155.237-.962.882-1.917 1.759-2.506.075-.05.196-.044.266.013zm.542-4.078l2.653 2.708.01.01c1.89 1.956 1.478 5.2-.687 6.638-.071.047-.166.038-.227-.022-.456-.445-.842-.877-1.18-1.425-.05-.084-.019-.193.068-.24.33-.179.659-.514.844-.869.221-.44.297-.935.18-1.446-.136-.654-.838-1.262-1.374-1.824L5.716 2.78c-.8-.817-2.118-.823-2.926-.015-.817.8-.831 2.124-.03 2.941l1.216 1.251c.057.058.075.143.048.22-.28.812-.349 1.957-.16 2.822.004.025-.026.04-.043.023l-2.59-2.643C-.422 5.69-.408 2.942 1.264 1.27c1.706-1.706 4.482-1.691 6.17.032z'
                transform='translate(-620 -283) translate(325 31) translate(285 242) translate(10 10)'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const SearchIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#FFF' fillRule='nonzero'>
        <g>
          <g>
            <g>
              <g>
                <path
                  d='M13.55 11.854c-.236-.236-.875-.47-1.918-.702 1.079-1.182 1.73-2.758 1.73-4.471C13.362 2.998 10.364 0 6.68 0S0 2.998 0 6.68c0 3.684 2.998 6.682 6.68 6.682 1.714 0 3.29-.651 4.472-1.73.217 1.016.451 1.656.702 1.918l2.09 2.09c.24.24.549.36.857.36.308 0 .617-.12.856-.36.463-.462.463-1.233 0-1.696l-2.107-2.09zm-6.87.137c-2.928 0-5.31-2.38-5.31-5.31 0-2.93 2.382-5.31 5.31-5.31 2.93 0 5.311 2.38 5.311 5.31 0 2.93-2.38 5.31-5.31 5.31z'
                  transform='translate(-666 -283) translate(325 31) translate(285 242) translate(46) translate(10 10)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const MailIcon = ({stroke='white'}) => {
  if(stroke === 'black') {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
      >
        <g fill='none' fillRule='evenodd'>
          <g fill='black' fillRule='nonzero' stroke='black' strokeWidth='0.1'>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d='M14 2c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h12zM2 12h12V6.894L8 10 2 7v5zm0-7l6 2.988L14 5V4H2v1z'
                      transform='translate(-804 -283) translate(325 31) translate(285 242) translate(184) translate(10 10)'
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg> 
    )
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#FFF' fillRule='nonzero'>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d='M14 2c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2H2c-1.105 0-2-.895-2-2V4c0-1.105.895-2 2-2h12zM2 12h12V6.894L8 10 2 7v5zm0-7l6 2.988L14 5V4H2v1z'
                    transform='translate(-804 -283) translate(325 31) translate(285 242) translate(184) translate(10 10)'
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )

}

export const ShareIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#FFF' fillRule='nonzero'>
        <g>
          <g>
            <g>
              <g>
                <path
                  d='M12.8 0C14.567 0 16 1.433 16 3.2c0 1.767-1.433 3.2-3.2 3.2-.963 0-1.827-.425-2.413-1.098L6.33 7.33c.046.216.07.44.07.67 0 .23-.024.454-.07.67l4.057 2.028c.586-.673 1.45-1.098 2.413-1.098 1.767 0 3.2 1.433 3.2 3.2 0 1.767-1.433 3.2-3.2 3.2-1.767 0-3.2-1.433-3.2-3.2 0-.23.024-.454.07-.67L5.614 10.1c-.587.674-1.45 1.1-2.414 1.1C1.433 11.2 0 9.767 0 8c0-1.767 1.433-3.2 3.2-3.2.963 0 1.827.425 2.413 1.098L9.67 3.87c-.046-.216-.07-.44-.07-.67 0-1.767 1.433-3.2 3.2-3.2zm0 11.2c-.884 0-1.6.716-1.6 1.6 0 .884.716 1.6 1.6 1.6.884 0 1.6-.716 1.6-1.6 0-.884-.716-1.6-1.6-1.6zM3.2 6.4c-.884 0-1.6.716-1.6 1.6 0 .884.716 1.6 1.6 1.6.884 0 1.6-.716 1.6-1.6 0-.884-.716-1.6-1.6-1.6zm9.6-4.8c-.884 0-1.6.716-1.6 1.6 0 .884.716 1.6 1.6 1.6.884 0 1.6-.716 1.6-1.6 0-.884-.716-1.6-1.6-1.6z'
                  transform='translate(-712 -283) translate(325 31) translate(285 242) translate(92) translate(10 10)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const TrackIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <g fill='none' fillRule='evenodd'>
      <g fill='#FFF' fillRule='nonzero'>
        <g>
          <g>
            <g>
              <g>
                <path
                  d='M8 .546c4.126 0 7.472 3.46 7.472 7.727C15.472 12.541 12.126 16 8 16S.528 12.54.528 8.273 3.874.546 8 .546zm0 1.546c-3.301 0-5.977 2.767-5.977 6.181S4.699 14.455 8 14.455s5.977-2.768 5.977-6.182c0-3.414-2.676-6.181-5.977-6.181zm.747 3.09V7.5h2.242v1.546l-2.242-.001v2.319H7.253l-.001-2.319h-2.24V7.502l2.24-.001V5.182h1.495zM13.385 0L16 2.704l-1.057 1.093-2.615-2.704L13.385 0zM2.615 0l1.057 1.093-2.615 2.704L0 2.704 2.615 0z'
                  transform='translate(-758 -283) translate(325 31) translate(285 242) translate(138) translate(10 10)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const ProfileEdit = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='35'
      height='35'
      viewBox='0 0 35 35'
    >
      <g fill='none' fillRule='evenodd'>
        <circle cx='17.5' cy='17.5' r='17.5' fill='#2A324B'></circle>
        <path
          fill='#FFF'
          d='M21.05 9.5c.524 0 1.026.21 1.392.579l2.481 2.48a1.968 1.968 0 010 2.785l-9.057 9.053c-.559.645-1.35 1.04-2.258 1.103H9.5v-.8l.003-3.372a3.236 3.236 0 011.058-2.154l9.095-9.094c.37-.371.87-.58 1.394-.58zm-3.309 4.755l-6.084 6.083c-.324.287-.525.688-.557 1.055V23.9l2.451.001c.428-.03.825-.229 1.145-.594l6.048-6.05-3.003-3.003zM21.05 11.1a.37.37 0 00-.26.108l-1.918 1.916 3.004 3.003 1.916-1.914a.373.373 0 000-.523l-2.483-2.482a.363.363 0 00-.26-.108z'
        ></path>
      </g>
    </svg>
  )
}

export const CheckCircleIcon = () => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    width='24px'
    height='24px'
    viewBox='0 0 122.881 122.88'
    enable-background='new 0 0 122.881 122.88'
  >
    <g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M61.44,0c33.933,0,61.441,27.507,61.441,61.439 c0,33.933-27.508,61.44-61.441,61.44C27.508,122.88,0,95.372,0,61.439C0,27.507,27.508,0,61.44,0L61.44,0z M34.106,67.678 l-0.015-0.014c-0.785-0.718-1.207-1.685-1.256-2.669c-0.049-0.982,0.275-1.985,0.984-2.777c0.01-0.011,0.019-0.021,0.029-0.031 c0.717-0.784,1.684-1.207,2.668-1.256c0.989-0.049,1.998,0.28,2.792,0.998l12.956,11.748l31.089-32.559v0 c0.74-0.776,1.723-1.18,2.719-1.204c0.992-0.025,1.994,0.329,2.771,1.067v0.001c0.777,0.739,1.18,1.724,1.205,2.718 c0.025,0.993-0.33,1.997-1.068,2.773L55.279,81.769c-0.023,0.024-0.048,0.047-0.073,0.067c-0.715,0.715-1.649,1.095-2.598,1.13 c-0.974,0.037-1.963-0.293-2.744-1L34.118,67.688L34.106,67.678L34.106,67.678L34.106,67.678z'
      />
    </g>
  </svg>
)

export function SelectCheckIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <g fill='none' fillRule='evenodd' transform='translate(1.5 1.5)'>
        <circle cx='10.5' cy='10.5' r='10.5' fill='#2A324B'></circle>
        <path
          stroke='#FFF'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M6.6 11.055l2.65 2.726 5.351-6.111'
        ></path>
      </g>
    </svg>
  )
}

export function MapPinLight() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='30'
      height='38'
      viewBox='0 0 30 38'
    >
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#577194'
          d='M4.532 4.752c-5.324 5.324-5.72 13.948-.968 19.756a.51.51 0 00.22.308l10.56 10.56c.132.132.308.22.528.264H8.8c-.484 0-.88.396-.88.88s.396.88.88.88h12.32c.484 0 .88-.396.88-.88s-.396-.88-.88-.88h-6.072c.176-.044.352-.088.528-.264l10.56-10.56c.088-.088.176-.176.22-.308 4.752-5.808 4.356-14.432-.968-19.756-5.764-5.764-15.092-5.764-20.856 0zM14.96 22c-3.872 0-7.04-3.168-7.04-7.04s3.168-7.04 7.04-7.04S22 11.088 22 14.96 18.832 22 14.96 22z'
        ></path>
        <circle cx='14.96' cy='14.96' r='5.28' fill='#53C3BD'></circle>
      </g>
    </svg>
  )
}

export function MapPinDark() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='30'
      height='38'
      viewBox='0 0 30 38'
    >
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#2A324B'
          d='M4.532 4.752c-5.324 5.324-5.72 13.948-.968 19.756a.51.51 0 00.22.308l10.56 10.56c.132.132.308.22.528.264H8.8c-.484 0-.88.396-.88.88s.396.88.88.88h12.32c.484 0 .88-.396.88-.88s-.396-.88-.88-.88h-6.072c.176-.044.352-.088.528-.264l10.56-10.56c.088-.088.176-.176.22-.308 4.752-5.808 4.356-14.432-.968-19.756-5.764-5.764-15.092-5.764-20.856 0zM14.96 22c-3.872 0-7.04-3.168-7.04-7.04s3.168-7.04 7.04-7.04S22 11.088 22 14.96 18.832 22 14.96 22z'
        ></path>
        <circle cx='14.96' cy='14.96' r='5.28' fill='#53C3BD'></circle>
      </g>
    </svg>
  )
}

export function MapPinAdd() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#7E868F'>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d='M7 17c2.714-4.675 7-5.242 7-10.058C14 3.117 10.857 0 7 0S0 3.117 0 6.942C0 11.758 4.286 12.467 7 17zM7 3.683c1.857 0 3.286 1.417 3.286 3.259C10.286 8.783 8.857 10.2 7 10.2S3.714 8.783 3.714 6.942C3.714 5.1 5.143 3.683 7 3.683z'
                      transform='translate(-334 -462) translate(302 373) translate(10 10) translate(12 41) translate(10 38) translate(5 4)'
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function CRMIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path
        fill='#FFF'
        fillRule='evenodd'
        d='M21.813 14.986a3.763 3.763 0 00-.763-.315 8.98 8.98 0 00.043-.84 8.961 8.961 0 00-5.22-8.139 3.841 3.841 0 00-5.911-4.025 3.841 3.841 0 00-1.584 4.025 8.962 8.962 0 00-5.22 8.138c0 .284.017.564.043.84-.265.078-.52.183-.762.316a3.843 3.843 0 104.512 6.16 8.932 8.932 0 0010.349 0 3.842 3.842 0 104.513-6.16zm-5.25 1.406a3.833 3.833 0 00-.046 3.737 7.643 7.643 0 01-8.783 0 3.817 3.817 0 00-3.261-5.644 7.46 7.46 0 01-.033-.655 7.687 7.687 0 014.427-6.95 3.82 3.82 0 006.517-.001 7.69 7.69 0 014.428 6.951c0 .221-.015.439-.034.655a3.83 3.83 0 00-3.215 1.907z'
      ></path>
    </svg>
  )
}

export function DashboardIcon() {
  return (
    <svg
      width='64px'
      height='64px'
      viewBox='-0.5 0 155 155'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
      <g
        id='SVGRepo_tracerCarrier'
        stroke-linecap='round'
        stroke-linejoin='round'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        {' '}
        <g clip-path='url(#clip0)'>
          {' '}
          <path
            d='M147.754 8.64794L148.453 8.51304C149.253 8.35804 150.009 8.21147 150.746 8.03896C151.547 7.87683 152.27 7.45016 152.799 6.82776C153.328 6.20529 153.633 5.42313 153.664 4.60663C153.695 3.79013 153.452 2.98673 152.973 2.32536C152.493 1.66399 151.805 1.18296 151.019 0.959567C149.476 0.499892 147.875 0.269647 146.265 0.276516C142.223 0.374445 138.116 0.51743 134.142 0.655565C128.745 0.842344 123.165 1.03614 117.679 1.1198C92.8631 1.49984 65.7555 1.84758 34.8053 2.18222C27.9566 2.25681 20.9996 2.08473 14.8615 1.93427C12.9062 1.88628 10.9113 1.72665 8.98328 1.57295C7.74566 1.47437 6.50802 1.37868 5.26976 1.3041C2.62532 1.15494 1.60164 2.60113 1.2146 3.84632C0.636316 5.70761 1.46616 7.48116 3.37931 8.47601C3.9443 8.75728 4.52506 9.0056 5.1187 9.21988L5.48175 9.36016C5.48175 10.6105 5.48436 11.8539 5.48955 13.0905C5.49668 15.9998 5.50509 19.0078 5.47591 21.9489C5.39682 30.0693 5.21661 38.327 5.03962 46.3124C4.54367 68.8734 4.03149 92.2025 5.75274 115.158C6.04123 119.005 7.28212 120.359 10.8582 120.732C13.8611 121.075 16.8823 121.233 19.9046 121.205C28.6075 121.016 37.4536 120.76 46.0086 120.512C49.506 120.409 53.004 120.309 56.5027 120.211C56.9981 120.197 57.4947 120.199 58.1332 120.203C57.9219 120.462 57.7164 120.715 57.518 120.958C56.6032 122.078 55.813 123.044 55.0791 124.061C50.5351 130.352 45.3843 137.486 40.3762 144.617C39.4934 145.968 38.8161 147.443 38.3664 148.993C38.0689 149.87 38.0693 150.822 38.3673 151.699C38.6654 152.577 39.2446 153.331 40.015 153.845C40.7204 154.367 41.576 154.645 42.4533 154.639C43.5487 154.624 44.6078 154.244 45.4634 153.56C46.2835 152.899 47.0182 152.138 47.6508 151.296C54.1851 142.884 60.7057 134.461 67.3198 125.919L72.0596 119.796L90.0384 119.208L93.6041 124.903C96.5403 129.598 99.4272 134.215 102.325 138.826C102.829 139.627 103.33 140.43 103.829 141.233C105.59 144.06 107.411 146.982 109.349 149.764C110.428 151.275 111.804 152.551 113.392 153.512C114.265 154.094 115.305 154.368 116.351 154.291C117.397 154.216 118.387 153.793 119.167 153.092C120.014 152.4 120.613 151.451 120.874 150.387C121.134 149.324 121.042 148.206 120.61 147.2C120.009 145.727 119.259 144.319 118.371 142.999C114.856 137.749 111.326 132.508 107.779 127.279C106.039 124.706 104.3 122.132 102.563 119.557C102.488 119.442 102.42 119.322 102.361 119.198C102.656 119.165 102.923 119.139 103.181 119.133C106.397 119.071 109.613 119.014 112.829 118.961C120.249 118.831 127.923 118.702 135.469 118.49C137.359 118.398 139.243 118.193 141.109 117.876C142.082 117.73 143.09 117.579 144.076 117.466C146.625 117.175 148.189 115.589 148.725 112.752C148.912 111.555 148.986 110.344 148.946 109.133V108.985C148.937 104.387 148.934 99.7898 148.936 95.191C148.936 83.341 148.932 71.0882 148.787 59.0358C148.657 48.2487 148.381 37.2842 148.116 26.6812C147.992 21.7113 147.872 16.7412 147.756 11.7712C147.739 10.9703 147.743 10.1682 147.749 9.33292C147.751 9.10853 147.753 8.88011 147.754 8.64794ZM16.4381 111.194L16.3895 111.18L16.3487 110.93C16.262 110.458 16.2037 109.981 16.1743 109.503C16.0498 106.325 15.9151 103.147 15.7704 99.9694C15.4385 92.4211 15.0948 84.616 14.9762 76.9406C14.7999 65.6106 14.7344 54.0869 14.6722 42.9431C14.6313 35.7631 14.5892 28.3382 14.5179 21.0357C14.4939 18.5544 14.3273 16.0789 14.1516 13.4575C14.0828 12.4289 14.0122 11.3765 13.948 10.2902C47.1633 11.3894 80.8383 10.6791 113.412 9.98651C121.645 9.81271 130.149 9.63313 138.545 9.48396V108.065C97.2164 107.474 56.2862 108.554 16.89 111.28C16.7368 111.266 16.5854 111.238 16.4381 111.194Z'
            fill='#000000'
          ></path>{' '}
          <path
            d='M129.763 30.0757C130.806 28.9307 131.543 27.5392 131.902 26.0315C132.084 25.364 132.101 24.6619 131.95 23.9865C131.8 23.311 131.486 22.6827 131.037 22.1561C130.588 21.6296 130.017 21.2205 129.374 20.9648C128.732 20.7092 128.036 20.6147 127.348 20.6893C126.033 20.8397 124.777 21.3187 123.694 22.0824C122.265 23.1156 120.908 24.2456 119.633 25.4641L119.298 25.77C109.536 34.6674 99.7584 43.5905 89.9658 52.5385L81.165 60.5736L81.1436 60.5635C77.8146 56.7287 73.7458 53.7084 69.8106 50.788C67.8566 49.3385 65.8358 47.8384 63.9434 46.2644C61.319 44.084 59.3683 44.0225 56.4879 46.031C54.9151 47.1538 53.4837 48.4624 52.2246 49.9286C49.4181 53.1297 46.5999 56.4139 43.8751 59.5885C41.6618 62.1679 39.4431 64.742 37.2189 67.3103C35.1374 69.7027 33.0437 72.0855 30.9375 74.4578C28.2367 77.5163 25.4438 80.6792 22.7352 83.8259C21.5741 85.1223 20.6579 86.6191 20.0311 88.2437C19.8824 88.8689 19.877 89.5194 20.0152 90.1472C20.1534 90.775 20.4317 91.3632 20.8291 91.8677C21.0832 92.1713 21.4018 92.4145 21.7618 92.5792C22.1217 92.7439 22.5138 92.8263 22.9095 92.8198C23.6723 92.7997 24.4139 92.5643 25.049 92.1414C25.5619 91.8113 26.0322 91.4189 26.4493 90.9741L28.7832 88.5245C36.9778 79.934 45.4511 71.0517 53.7579 62.2884C55.1387 60.8318 56.4885 59.2982 57.918 57.6736C58.4788 57.0368 59.0597 56.3765 59.6684 55.6884C60.6802 56.7512 61.6788 57.8037 62.6643 58.8466C65.6394 61.9881 68.4498 64.9568 71.3659 67.9076C72.728 69.2909 74.2729 70.4816 75.9578 71.4473C78.2671 72.7547 80.4733 72.7651 82.3346 71.4778C83.8257 70.4784 85.2636 69.4031 86.6432 68.2546L90.922 64.5916C100.21 56.6405 109.813 48.419 119.184 40.2448C122.973 36.936 126.508 33.3988 129.763 30.0757Z'
            fill='#000000'
          ></path>{' '}
        </g>{' '}
        <defs>
          {' '}
          <clipPath id='clip0'>
            {' '}
            <rect
              width='153'
              height='155'
              fill='white'
              transform='translate(0.777344)'
            ></rect>{' '}
          </clipPath>{' '}
        </defs>{' '}
      </g>
    </svg>

    // <svg
    //   viewBox='0 0 64 64'
    //   fill='none'
    //   xmlns='http://www.w3.org/2000/svg'
    //   stroke='#000000'
    //   stroke-width='0.512'
    // >
    //   <g id='SVGRepo_bgCarrier' stroke-width='0'></g>
    //   <g
    //     id='SVGRepo_tracerCarrier'
    //     stroke-linecap='round'
    //     stroke-linejoin='round'
    //   ></g>
    //   <g id='SVGRepo_iconCarrier'>
    //     {' '}
    //     <path
    //       d='M55.64 22.751H35.09C34.5596 22.751 34.0509 22.9617 33.6758 23.3368C33.3007 23.7118 33.09 24.2205 33.09 24.751V55.571C33.0916 56.1009 33.3028 56.6087 33.6775 56.9834C34.0523 57.3582 34.5601 57.5694 35.09 57.571H55.64C56.1699 57.5694 56.6777 57.3582 57.0525 56.9834C57.4272 56.6087 57.6384 56.1009 57.64 55.571V24.751C57.64 24.2205 57.4293 23.7118 57.0542 23.3368C56.6791 22.9617 56.1704 22.751 55.64 22.751Z'
    //       fill='#ffffff'
    //     ></path>{' '}
    //     <path
    //       d='M55.64 5.62695H35.09C34.5596 5.62695 34.0509 5.83767 33.6758 6.21274C33.3007 6.58781 33.09 7.09652 33.09 7.62695V17.8969C33.0916 18.4269 33.3028 18.9347 33.6775 19.3094C34.0523 19.6841 34.5601 19.8954 35.09 19.8969H55.64C56.1699 19.8954 56.6777 19.6841 57.0525 19.3094C57.4272 18.9347 57.6384 18.4269 57.64 17.8969V7.62695C57.64 7.09652 57.4293 6.58781 57.0542 6.21274C56.6791 5.83767 56.1704 5.62695 55.64 5.62695Z'
    //       fill='#ffffff'
    //     ></path>{' '}
    //     <path
    //       d='M28.24 36.451H7.7C6.59543 36.451 5.7 37.3465 5.7 38.451V55.5711C5.7 56.6756 6.59543 57.5711 7.7 57.5711H28.24C29.3446 57.5711 30.24 56.6756 30.24 55.5711V38.451C30.24 37.3465 29.3446 36.451 28.24 36.451Z'
    //       fill='#ffffff'
    //     ></path>{' '}
    //     <path
    //       d='M28.24 5.62697H7.70002C7.43712 5.62604 7.17661 5.67714 6.93355 5.77733C6.69048 5.87751 6.46964 6.02477 6.28373 6.21068C6.09783 6.39658 5.95054 6.61742 5.85035 6.86049C5.75017 7.10355 5.6991 7.36406 5.70002 7.62697V31.557C5.70002 32.0874 5.91074 32.5961 6.28581 32.9712C6.66088 33.3462 7.16959 33.557 7.70002 33.557H28.24C28.7704 33.557 29.2791 33.3462 29.6542 32.9712C30.0293 32.5961 30.24 32.0874 30.24 31.557V7.62697C30.2409 7.36406 30.1898 7.10355 30.0896 6.86049C29.9895 6.61742 29.8422 6.39658 29.6563 6.21068C29.4704 6.02477 29.2495 5.87751 29.0065 5.77733C28.7634 5.67714 28.5029 5.62604 28.24 5.62697Z'
    //       fill='#ffffff'
    //     ></path>{' '}
    //   </g>
    // </svg>
  )
}

export function RedClock({ ...props }) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='25'
      height='20'
      viewBox='0 0 19 20'
    >
      <path
        fill='#F44336'
        fillRule='evenodd'
        d='M9.5 3.667a6.333 6.333 0 110 12.666 6.333 6.333 0 110-12.666zm0 1.583a4.75 4.75 0 100 9.5 4.75 4.75 0 000-9.5zm.795 1.582v2.375h1.582v1.583H8.711V6.832h1.584z'
      ></path>
    </svg>
  )
}

export function Iconlinkdin() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#2A324B'>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d='M4.27 5.485v9.287H1.181V5.485H4.27zm7.576-.218c2.031 0 3.554 1.327 3.554 4.18v5.325h-3.087V9.803c0-1.248-.446-2.1-1.563-2.1-.853 0-1.361.575-1.584 1.129-.082.198-.102.476-.102.753v5.187H5.977V5.485h3.087V6.83s1.117-1.564 2.782-1.564zm-9.1-4.26c1.056 0 1.706.694 1.726 1.605 0 .891-.67 1.605-1.746 1.605h-.02C1.67 4.217 1 3.503 1 2.612c0-.911.69-1.605 1.746-1.605z'
                      transform='translate(-175 -403) translate(74 181) translate(1 30) translate(90 182) translate(10 10)'
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function Icontwitter() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#2A324B'>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <g>
                        <path
                          d='M14.356 3.252c.65-.462 1.198-1.038 1.644-1.702-.595.26-1.229.433-1.89.517.68-.406 1.2-1.044 1.443-1.813-.634.378-1.334.645-2.08.794C12.871.408 12.013.01 11.077.01 9.261.01 7.8 1.484 7.8 3.291c0 .26.022.51.076.748C5.15 3.906 2.735 2.6 1.114.608c-.283.491-.45 1.053-.45 1.658 0 1.136.585 2.142 1.458 2.726-.527-.01-1.044-.164-1.482-.404v.036c0 1.594 1.137 2.918 2.628 3.223-.267.073-.558.108-.86.108-.21 0-.422-.012-.62-.056.424 1.299 1.63 2.254 3.064 2.285-1.116.873-2.533 1.4-4.067 1.4-.269 0-.527-.013-.785-.046 1.453.937 3.175 1.472 5.032 1.472 5.789 0 9.561-4.829 9.324-9.758z'
                          transform='translate(-221 -403) translate(74 181) translate(1 30) translate(90 182) translate(46) translate(10 10) translate(0 2)'
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function Iconfacebook() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#2A324B'>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <g>
                        <path
                          d='M7.23.003L5.43 0C3.41 0 2.103 1.34 2.103 3.414v1.574H.294c-.156 0-.283.127-.283.284v2.28c0 .157.127.283.283.283h1.809v5.756c0 .156.126.282.283.282h2.36c.156 0 .283-.126.283-.282V7.835h2.115c.156 0 .283-.126.283-.283v-2.28c0-.076-.03-.147-.082-.2-.053-.054-.125-.084-.2-.084H5.028V3.654c0-.641.153-.967.988-.967H7.23c.156 0 .283-.127.283-.283V.286c0-.156-.127-.283-.283-.283z'
                          transform='translate(-267 -403) translate(74 181) translate(1 30) translate(90 182) translate(92) translate(10 10) translate(4 1)'
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function Iconinstagram() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#2A324B'>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        d='M10.8 1C13.12 1 15 2.88 15 5.2v5.6c0 2.32-1.88 4.2-4.2 4.2H5.2C2.88 15 1 13.12 1 10.8V5.2C1 2.88 2.88 1 5.2 1h5.6zm0 1.4H5.2c-1.546 0-2.8 1.254-2.8 2.8v5.6c0 1.546 1.254 2.8 2.8 2.8h5.6c1.546 0 2.8-1.254 2.8-2.8V5.2c0-1.546-1.254-2.8-2.8-2.8zM8 4.5c1.933 0 3.5 1.567 3.5 3.5S9.933 11.5 8 11.5 4.5 9.933 4.5 8 6.067 4.5 8 4.5zm0 1.4c-1.16 0-2.1.94-2.1 2.1 0 1.16.94 2.1 2.1 2.1 1.16 0 2.1-.94 2.1-2.1 0-1.16-.94-2.1-2.1-2.1zm3.5-2.1c.387 0 .7.313.7.7 0 .387-.313.7-.7.7-.387 0-.7-.313-.7-.7 0-.387.313-.7.7-.7z'
                        transform='translate(-313 -403) translate(74 181) translate(1 30) translate(90 182) translate(138) translate(10 10)'
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function Iconcollapsearrow() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#7E868F'>
          <g>
            <g>
              <path
                d='M12.707 13.293L11.293 14.707 4.586 8 11.293 1.293 12.707 2.707 7.414 8z'
                transform='translate(-58 -24) translate(53 13) translate(5 11) matrix(-1 0 0 1 17.293 0)'
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function EditIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
    >
      <path
        fill='#7E868F'
        fillRule='evenodd'
        d='M11.55 0c.524 0 1.026.21 1.393.579l2.48 2.48a1.969 1.969 0 01.001 2.786l-9.058 9.054c-.559.645-1.35 1.041-2.258 1.103H0v-.8l.003-3.372a3.238 3.238 0 011.058-2.155L10.157.58c.368-.371.87-.58 1.393-.58zM8.241 4.755L2.157 10.84c-.324.287-.525.688-.557 1.055v2.508l2.451.001c.428-.03.826-.229 1.145-.594l6.049-6.051-3.004-3.004zm3.31-3.155a.367.367 0 00-.26.108L9.373 3.624l3.003 3.004 1.916-1.915a.365.365 0 00.108-.26.366.366 0 00-.108-.262L11.81 1.708a.36.36 0 00-.259-.108z'
      ></path>
    </svg>
  )
}

export function ClockIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='30'
      height='30'
      viewBox='0 0 24 24'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#7E868F'>
          <g>
            <g>
              <g>
                <path
                  d='M12 4c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 2c-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm1.004 1.998v3h1.999v2h-4v-5h2z'
                  transform='translate(-934 -344) translate(419 134) translate(311 202) translate(204 8)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export const BookmarkIcon = () => (
  <svg
    width='11'
    height='14'
    viewBox='0 0 11 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.5 14L5.5 11.6234L10.5 14V1.35803C10.5 0.608013 9.86041 0 9.07143 0H1.92857C1.13959 0 0.5 0.608013 0.5 1.35803V14ZM5.5 10.1051L1.92857 11.8027V1.35803H9.07143V11.8027L5.5 10.1051Z'
      fill='#FFF'
    />
  </svg>
)

export const AddressBookIcon = () => (
  <svg
    width='17'
    height='18'
    viewBox='0 0 17 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.7802 0.75H2.86465C2.50538 0.75 2.21797 1.02807 2.21797 1.37565V3.60018H1.01443C0.780909 3.60018 0.583313 3.79135 0.583313 4.01728V5.04265C0.583313 5.26858 0.780909 5.45975 1.01443 5.45975H2.21797V8.06663H1.01443C0.780909 8.06663 0.583313 8.2578 0.583313 8.48373V9.5091C0.583313 9.73503 0.780909 9.9262 1.01443 9.9262H2.21797V12.5331H1.01443C0.780909 12.5331 0.583313 12.7242 0.583313 12.9502V13.9755C0.583313 14.2015 0.780909 14.3926 1.01443 14.3926H2.21797V16.6172C2.21797 16.9648 2.50538 17.2428 2.86465 17.2428H15.7623C16.1216 17.2428 16.409 16.9648 16.409 16.6172V1.37565C16.4269 1.02807 16.1395 0.75 15.7802 0.75ZM15.1336 16.0089H3.51133V2.00129H15.1336V16.0089ZM9.32951 13.7707C8.11532 13.7707 6.92281 13.6686 5.79534 13.4813C5.1232 13.3792 4.68956 12.8856 4.75461 12.341L5.01479 10.656C5.16656 9.7028 5.94712 8.91986 6.98785 8.54541C6.42412 8.08586 6.07721 7.4561 6.07721 6.77529C6.07721 5.36259 7.5299 4.22222 9.32951 4.22222C11.1291 4.22222 12.5818 5.36259 12.5818 6.77529C12.5818 7.4561 12.2349 8.08586 11.6712 8.54541C12.7336 8.91986 13.4925 9.7028 13.6442 10.656L13.9044 12.341C13.9695 12.8856 13.5358 13.3622 12.8637 13.4813C11.7362 13.6686 10.5437 13.7707 9.32951 13.7707ZM11.0207 6.77533C11.0207 6.04345 10.2618 5.44773 9.32951 5.44773C8.39718 5.44773 7.63831 6.04345 7.63831 6.77533C7.63831 7.50721 8.39718 8.10293 9.32951 8.10293C10.2618 8.10293 11.0207 7.50721 11.0207 6.77533ZM6.5759 10.6996C6.68431 10.0305 7.48654 9.53259 8.41887 9.53259H10.2618C11.1942 9.53259 11.9964 10.0305 12.1048 10.6996L12.3433 12.0845C10.4136 12.3646 8.28877 12.3646 6.35908 12.0845L6.5759 10.6996Z'
      fill='white'
    />
  </svg>
)

export function TaskcompleteIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='31'
      height='31'
      viewBox='0 0 31 31'
    >
      <g fill='none' fill-rule='evenodd'>
        <g>
          <g>
            <path
              fill='#53C3BD'
              d='M15.5 31C6.94 31 0 24.06 0 15.5 0 6.94 6.94 0 15.5 0 24.06 0 31 6.94 31 15.5 31 24.06 24.06 31 15.5 31z'
              transform='translate(-1745 -2672) translate(1745 2672)'
            />
            <path
              fill='#FFF'
              d='M13.628 17.517L20.235 11 22 12.741 13.628 21 9 16.435 10.765 14.694z'
              transform='translate(-1745 -2672) translate(1745 2672)'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function TasknormalIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='31'
      height='31'
      viewBox='0 0 31 31'
    >
      <g fill='none' fill-rule='evenodd'>
        <g>
          <g>
            <path
              stroke='#7E868F'
              stroke-width='2'
              d='M15.5 1c4.004 0 7.63 1.623 10.253 4.247C28.377 7.871 30 11.496 30 15.5c0 4.004-1.623 7.63-4.247 10.253C23.129 28.377 19.504 30 15.5 30c-4.004 0-7.63-1.623-10.253-4.247C2.623 23.129 1 19.504 1 15.5c0-4.004 1.623-7.63 4.247-10.253C7.871 2.623 11.496 1 15.5 1z'
              transform='translate(-1790 -2670) translate(1790 2670)'
            />
            <path
              fill='#7E868F'
              d='M13.628 17.517L20.235 11 22 12.741 13.628 21 9 16.435 10.765 14.694z'
              transform='translate(-1790 -2670) translate(1790 2670)'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function DownarrowIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
    >
      <g fill='none' fill-rule='evenodd'>
        <g fill='#7E868F'>
          <g>
            <path
              d='M9.97 3.22L11.03 4.28 6 9.311 0.97 4.28 2.03 3.22 6 7.189z'
              transform='translate(-1853 -2678) translate(1853 2678)'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function DeleteIconSmall() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path
        fill='#7E868F'
        fillRule='evenodd'
        d='M14.1 4.4a1.4 1.4 0 011.4 1.4v.7h2.1A1.4 1.4 0 0119 7.9v1.4a1.4 1.4 0 01-1.4 1.4h-.057l-.643 7.7a1.4 1.4 0 01-1.4 1.4h-7c-.773 0-1.4-.627-1.398-1.342L6.456 10.7H6.4A1.4 1.4 0 015 9.3V7.9a1.4 1.4 0 011.4-1.4h2.1v-.7a1.4 1.4 0 011.4-1.4h4.2zm2.039 6.3H7.86l.64 7.7h7l.002-.058.637-7.642zM17.6 7.9H6.4v1.4h11.2V7.9zm-3.5-2.1H9.9v.7h4.2v-.7z'
      ></path>
    </svg>
  )
}

export function AddcommentIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='10'
      viewBox='0 0 14 10'
    >
      <g fill='none' fillRule='evenodd'>
        <g fill='#7E868F' fillRule='nonzero'>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <g>
                        <path
                          d='M8.862 3.278h-6.77L4.607.77 3.834 0 0 3.823l3.834 3.822.773-.77-2.515-2.507h6.77c2.23 0 4.045 1.809 4.045 4.033v.903H14v-.903c0-2.825-2.305-5.123-5.138-5.123z'
                          transform='translate(-491 -824) translate(443 181) translate(1 107) translate(15) translate(0 218) translate(16 303) translate(16 12) matrix(1 0 0 -1 0 12.304)'
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export function EditIconSmall() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
    >
      <path
        fill='#7E868F'
        d='M11.55 0c.524 0 1.026.21 1.393.579l2.48 2.48a1.969 1.969 0 01.001 2.786l-9.058 9.054c-.559.645-1.35 1.041-2.258 1.103H0v-.8l.003-3.372a3.238 3.238 0 011.058-2.155L10.157.58c.368-.371.87-.58 1.393-.58zM8.241 4.755L2.157 10.84c-.324.287-.525.688-.557 1.055v2.508l2.451.001c.428-.03.826-.229 1.145-.594l6.049-6.051-3.004-3.004zm3.31-3.155a.367.367 0 00-.26.108L9.373 3.624l3.003 3.004 1.916-1.915a.365.365 0 00.108-.26.366.366 0 00-.108-.262L11.81 1.708a.36.36 0 00-.259-.108z'
      ></path>
    </svg>
  )
}

export function AttendingIcon() {
  return (
    <svg width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
      <g transform='translate(1.5 1.5)' fill='none' fill-rule='evenodd'>
        <circle fill='#2A324B' cx='10.5' cy='10.5' r='10.5' />
        <path
          stroke='#FFF'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
          d='m6.6 11.055 2.65 2.726 5.35-6.11'
        />
      </g>
    </svg>
  )
}

export function CommunityIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='200'
      height='200'
      viewBox='5 12 52 48'
    >
      <path
        class='cls-2'
        d='M32.69,14.76A7,7,0,0,0,25.74,21,18.73,18.73,0,0,0,15.29,31.48a7,7,0,0,0,0,13.91A18.76,18.76,0,0,0,25.74,55.84a7,7,0,0,0,13.91,0A18.76,18.76,0,0,0,50.1,45.39a7,7,0,0,0,0-13.91A18.74,18.74,0,0,0,39.65,21,7,7,0,0,0,32.69,14.76Zm0,3a4.07,4.07,0,1,1-4.06,4.06A4,4,0,0,1,32.69,17.72Zm-6.61,6.35a7,7,0,0,0,13.23,0,15.88,15.88,0,0,1,7.75,7.75,7,7,0,0,0,0,13.23,15.84,15.84,0,0,1-7.74,7.74,7,7,0,0,0-13.22,0,15.78,15.78,0,0,1-7.75-7.74,7,7,0,0,0,0-13.23A15.88,15.88,0,0,1,26.08,24.07ZM16,34.37A4.07,4.07,0,1,1,12,38.43,4,4,0,0,1,16,34.37Zm33.3,0a4.07,4.07,0,1,1-4.06,4.06A4,4,0,0,1,49.34,34.37ZM32.69,51a4.07,4.07,0,1,1-4.06,4.06A4,4,0,0,1,32.69,51Z'
      />
    </svg>
  )
}
